/* dcsax-tool-clarinet.js
   Serial tool script, moved out of the Shopify page body 2026-09-28 so one copy serves every
   language. Translate & Adapt copies a page body, script included, into each language, which
   froze old scripts on /ja. Loaded by the dcsax_tool_css section in sections/header-group.json,
   only when the page body has no inline <script> of its own. Source: theme/staged-i18n-2026-09-28/clarinet-lookup-page-body.txt
   Korean (ko) added 2026-09-29, staged in theme/staged-ko-2026-09-29/. Any language with a
   dictionary in DCSAX_I18N gets its own text; English is the fallback. */

(function () {
  var DATA = {"brandOrder":["buffet-pro","buffet-e13","buffet-harmony","buffet-student"],"brands":{"buffet-pro":{"name":"Professional line (R13 and its relatives)","sections":[{"label":"Numeric serials from 1928 (one sequence for pre-R13, R13, RC, Festival, Prestige, Vintage, Tosca, Divine)","min":1,"steps":[[2500,"1928"],[4999,"1929"],[7499,"1930"],[9999,"1931"],[12500,"1932"],[15000,"1933"],[18000,"1934"],[20000,"1935"],[22000,"1936"],[24000,"1937"],[26000,"1938"],[27000,"1939"],[28000,"1940–45"],[58834,"c. 1946–57"],[59143,"1958"],[62457,"1959"],[65956,"1960"],[69717,"1961"],[75319,"1962"],[78093,"1963"],[93203,"1964–66"],[99331,"1967"],[105617,"1968"],[111416,"1969"],[117747,"1970"],[126209,"1971"],[133903,"1972"],[143517,"1973"],[153323,"1974"],[163567,"1975"],[173826,"1976"],[183901,"1977"],[191872,"1978"],[201531,"1979"],[210652,"1980"],[221260,"1981"],[234695,"1982"],[250371,"1983"],[266396,"1984"],[277482,"1985"],[292267,"1986"],[302623,"1987"],[312699,"1988"],[324769,"1989"],[337910,"1990"],[352250,"1991"],[367799,"1992"],[379340,"1993"],[394000,"1994"],[408000,"1995"],[423000,"1996"],[439774,"1997"]],"fallback":"1998 or later","hardMax":2000000}],"lettered":[["1885","1A–498A"],["1886","409A–999A, A1–A886"],["1887","A887–A999, B1–B999, 1B–417B"],["1888","418B–999B, 1C–999C, C1–C300"],["1889","C301–C999, D1–D999, 1D–348D"],["1890","349D–999D, E1–E999, 1E–316E"],["1891","317E–999E, F1–F999, 1F–190F"],["1892","191F–999F, G1–G999, 1G–58G"],["1893","59G–999G, H1–H999, 1H–184H"],["1894","185H–999H, I1–I665"],["1895","I666–I999, 1I–999I, J1–J617"],["1896","J618–J999, 1J–999J, K1–K514"],["1897","K515–K999, 1K–999K, L1–L561"],["1898","L562–L999, 1L–999L, M1–M590"],["1899","M591–M999, 1M–999M, N1–N440"],["1900","N441–N999, 1N–999N, O1–O521"],["1901","O522–O999, 1O–999O, P1–P999, 1P–374P"],["1902","375P–999P, R1–R999, 1R–404R"],["1903","405R–999R, S1–S999, 1S–999S, T1–T40"],["1904","T41–T999, 1T–999T, U1–U999, 1U–81U"],["1905","82U–999U, V1–V999, 1V–751V"],["1906","752V–999V, X1–X999, 1X–999X, Y1–Y840"],["1907","Y841–Y999, 1Y–999Y, Z1–Z999, 1Z–812Z"],["1908","813Z–999Z, 1A1–1A999, 2A1–2A999, 1B1–1B999, 2B1–2B60"],["1909","2B61–2B999, 1C1–1C999, 2C1–2C999"],["1910","1D68–1D999, 2D1–2D999, 1E1–1E901"],["1911","1E902–1E999, 2E1–2E999, 1F1–1F999, 2F1–2F763"],["1912","2F764–2F999, 1G1–1G999, 2G1–2G999, 1H1–1H500"],["1913","1H501–1H999, 2H1–2H999"],["1914","1J1–1J999, 2J1–2J224"],["1915","2J225–2J999, 1K1–1K341"],["1916","1K342–1K999, 2K1–2K460"],["1917","2K461–2K999, 1L11–1L521"],["1918","1L522–1L999, 2L1–2L661"],["1919","2L662–2L999, 1M1–1M800"],["1920","1M801–1M999, 2M1–2M999"],["1921","1N1–1N999, 2N1–2N999"],["1922","1O1–1O999, 2O1–2O168"],["1923","2O169–2O999, 1P1–1P999, 2P1–2P536"],["1924","2P537–2P999, 1R1–1R999, 2R1–2R226"],["1925","2R227–2R999, 1S1–1S876"],["1926","1S877–1S999, 2S1–2S999, 1T1–1T508"],["1927","1T509–1T542"]],"letteredLabel":"Lettered serials 1885–1927 (a letter with a number, such as 1K630 or 498A)","letteredModel":"Pre-R13 (lettered era)","letteredNote":"Lettered stamps put a letter before or after the number, and from 1908 a digit in front of the letter. Type it exactly as stamped.","note":"Charts per adams-music.shop, matching shopforband and Granlund (two source typos corrected). Buffet&rsquo;s records for 1946–57 and 1964–66 were lost, so those bands are estimates at about 3,000 instruments a year. The sources disagree on whether 1961 ends at 68,717 or 69,717; 1962 starts at 69,718 either way, and the chart reads the disputed thousand as 1961. Public charts stop at 439,774 (1997); a higher number is 1998 or later.","caveats":[{"lo":28001,"hi":58834,"html":"<strong>Records lost:</strong> Buffet&rsquo;s books for 1946 to 1957 did not survive, so the band shown is an estimate from the surrounding years at about 3,000 instruments a year, not a factory date."},{"lo":78094,"hi":93203,"html":"<strong>Records lost:</strong> Buffet&rsquo;s books for 1964 to 1966 did not survive, so the band shown is an estimate, not a factory date."},{"lo":68718,"hi":69717,"html":"<strong>Disputed thousand:</strong> published charts disagree on whether 1961 ends at 68,717 or 69,717. This number is read as 1961; 1962 starts at 69,718 in every source."},{"yearHas":"1998 or later","html":"<strong>Past the public charts:</strong> every published Buffet list stops at 439,774 (1997). A higher number is 1998 or later; the stamp and case style narrow it, and we are glad to look at a photo: <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>."}]},"buffet-e13":{"name":"E13 (French intermediate)","sections":[{"label":"E13, its own sequence","min":10109,"steps":[[16377,"1961–65"],[23007,"1966–68"],[29623,"1969–72"],[32167,"1973–74"],[42803,"1975–76"],[49092,"1977–78"],[56536,"1979–80"],[62684,"1981–82"]],"fallback":"1983 or later","hardMax":99999}],"note":"E13 numbers per adams-music.shop, a single source, given as the serial at the start of each listed year. The E13 sequence sits numerically inside the professional sequence, which is why the line is chosen first."},"buffet-harmony":{"name":"Harmony clarinets (E-flat, alto, bass, contra)","sections":[{"label":"Harmony clarinets, their own sequence","min":19506,"steps":[[19578,"1950"],[19638,"1951"],[19680,"1952"],[19781,"1953"],[19965,"1954"],[20091,"1955"],[20154,"1956–57"],[20237,"1958"],[20401,"1959"],[20502,"1960"],[20511,"1961"],[20692,"1962"],[20775,"1963"],[20854,"1964"],[20911,"1965"],[21054,"1966"],[21209,"1967"],[21358,"1968"],[21432,"1969"],[21500,"1970"],[21557,"1971"],[21627,"1972"],[21702,"1973"],[21796,"1974"],[21953,"1975"],[21999,"1976"],[22114,"1977"],[22233,"1978"],[22350,"1979"],[22461,"1980"],[22535,"1981"],[22692,"1982"],[22859,"1983"],[23059,"1984"],[23274,"1985"],[23462,"1986"],[23619,"1987"],[23875,"1988"],[24190,"1989"],[24508,"1990"],[25221,"1991"],[26077,"1992"],[26078,"1993"]],"fallback":"1994 or later","hardMax":40000}],"note":"Harmony (E-flat, alto, bass and contra) numbers per adams-music.shop, a single source. The sequence starts at 19,506 in 1950 and runs a few dozen to a few hundred instruments a year."},"buffet-student":{"name":"E11 / E12 / B10 / B12 (student)","sections":[],"noChart":"<strong>No public chart exists for these models.</strong> The E11, E12, B10, B12 and German-stamped Evette clarinets were built by Schreiber in Germany on Schreiber&rsquo;s own numbering, and no year list has been published. If you would like an opinion on the age, email a photo of the stamps on both joints to <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.","note":""}},"models":{"buffet-pro":[[1,45450,"Pre-R13"],[45451,60999,"Earliest R13s (lowest reported 45,451; the name was adopted in 1955)"],[61000,2000000,"R13 family (polycylindrical bore); RC, Festival, Prestige, Vintage, Tosca and Divine share the sequence"]]},"search":{"buffet-pro":{"byModel":{"Earliest R13s (lowest reported 45,451; the name was adopted in 1955)":["R13","Buffet clarinet"],"R13 family (polycylindrical bore); RC, Festival, Prestige, Vintage, Tosca and Divine share the sequence":["R13","Buffet clarinet"],"Pre-R13":["Buffet clarinet"],"Pre-R13 (lettered era)":["Buffet clarinet"]},"base":["Buffet clarinet"],"fallback":["clarinet"]},"buffet-e13":{"base":["E13","Buffet clarinet"],"fallback":["clarinet"]},"buffet-harmony":{"base":["bass clarinet","Buffet clarinet"],"fallback":["clarinet"]},"buffet-student":{"base":["Buffet clarinet"],"fallback":["clarinet"]}},"voiceNotes":{},"facts":{"buffet-pro":[[1,"An F before the serial means the instrument was built to A=442–444 for European orchestras"],[45451,"Lowest reported R13 serial is 45,451 (1953). The R13 name was adopted in 1955"],[61000,"The polycylindrical bore arrives around 61,000, the R13 as players know it"],[439775,"Public year charts stop at 439,774 (1997). Later serials get an era, not a year, until a source is found"]]},"patents":[]};
  var BRAND_ORDER = DATA.brandOrder;
  var COPY = {"noun":"clarinet","serialWhere":"on the upper joint, and usually the lower joint, barrel and bell as well","brandLabel":"Select Your Clarinet Line","placeholder":"e.g. 157738 or 1K630","seeSoldLabel":"See Similar Clarinets","sellHref":"mailto:paul@dcsax.com?subject=Buffet%20clarinet","sellLabel":"Email Us About Yours","sellBox":false,"hasYamaha":false,"pillMinWidth":"260px","soldEmpty":"Nothing similar for sale or in our sold archives right now. Email <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> and we will take a look at yours."};
  // DCSAX_I18N: per-locale strings, keyed on <html lang>, English fallback.
  // Same mechanism as the saxophone lookup. Model codes, brand names, serials,
  // emails and years stay as they are. Every localized branch is guarded by
  // DCSAX_LOC, so the English page renders exactly as before. Strings from a
  // data object are keyed by their path in that object.
  var DCSAX_LANG_FULL = String(document.documentElement.getAttribute("lang") || "en").toLowerCase();
  var DCSAX_LANG = DCSAX_LANG_FULL.split("-")[0];
  var DCSAX_I18N = {
    ja: {
      copy: {
        "placeholder": "例：157738、1K630",
        "soldEmpty": "現在、販売中の商品にも売却済みアーカイブにも、似たクラリネットはありません。<a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> までメールをいただければ、お手持ちのクラリネットを拝見します。"
      },
      s: {
        "sn.label": "シリアルナンバーを入力",
        "nudge.brand": "<strong>あと一歩です：</strong>上でクラリネットのラインを選ぶと、シリアルナンバー <strong>{0}</strong> の製造年がわかります。",
        "prompt.empty": "<em>クラリネットに刻印されているシリアルナンバーを入力してください。</em>",
        "result.yearLabel": "製造年",
        "result.model": "<strong>推定モデル：</strong>{0}",
        "result.letteredNoMatch": "<strong>該当なし：</strong>この文字入りの刻印は、公開されている1885〜1927年の表にありません（この表には小さな欠けがあります）。クラリネットの文字と数字を確認してください。それでも一致しない場合は、刻印の写真を <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> までメールでお送りください。",
        "result.masked": "<strong>あと一歩です：</strong>シリアルナンバーの一部が隠れているか、読み取れないようです（「xxx」の部分）。シリアルナンバーは上管に刻印されていて、通常は下管、バレル、ベルにもあります。刻印されている数字をすべて入力してください。",
        "result.unparsed": "<em>1つのシリアルナンバーとして読み取れません。クラリネットに刻印されている数字だけを入力してください。</em>",
        "result.noMatch": "<strong>該当なし：</strong>この番号は、記録されている{0}のシリアルナンバーの範囲に入りません。クラリネットの数字をもう一度確認してください。それでも一致しない場合は、写真を <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> までメールでお送りください。拝見します。",
        "year.plain": "{0}年",
        "year.range": "{0}〜{1}年",
        "year.orLater": "{0}年以降",
        "year.approx": "{0}頃",
        "chart.title": "{0}のシリアルナンバー表で、お手持ちのクラリネットが当てはまる位置",
        "chart.th.serial": "シリアルナンバー",
        "chart.th.year": "製造年",
        "chart.th.model": "モデルの時期",
        "chart.lettered": "文字入りのシリアルナンバー",
        "chart.andUp": "{0}以上",
        "save.sheet": "開いたメニューで<strong>ブックマークに追加</strong>または<strong>ホーム画面に追加</strong>を選んでください。",
        "save.tap": "ブラウザの共有アイコンをタップし、<strong>ブックマークに追加</strong>を選んでください。",
        "save.press": "<strong>{0}</strong>を押すと、このページをブックマークできます。",
        "save.copied": "リンクをコピーしました。",
        "save.copyThis": "このリンクをコピーしてください：<strong>{0}</strong>",
        "sold.loading": "販売中の商品と売却済みアーカイブを探しています…",
        "sold.badge": "売却済み",
        "brands.buffet-pro.name": "プロフェッショナル・ライン（R13系）",
        "brands.buffet-e13.name": "E13（フランス製の中級モデル）",
        "brands.buffet-harmony.name": "ハーモニー・クラリネット（E♭、アルト、バス、コントラ）",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12（初心者・学生向け）",
        "brands.buffet-pro.sections.0.label": "1928年以降の数字だけのシリアルナンバー（R13以前のモデル、R13、RC、Festival、Prestige、Vintage、Tosca、Divineで1つの連番）",
        "brands.buffet-e13.sections.0.label": "E13（独自の連番）",
        "brands.buffet-harmony.sections.0.label": "ハーモニー・クラリネット（独自の連番）",
        "brands.buffet-pro.letteredLabel": "1885〜1927年の文字入りのシリアルナンバー（1K630や498Aのような、文字と数字の組み合わせ）",
        "brands.buffet-pro.letteredModel": "R13以前（文字入りシリアルの時代）",
        "brands.buffet-pro.letteredNote": "文字入りの刻印では、数字の前または後ろに文字が入ります。1908年からは、文字の前にさらに数字が1桁入ります。刻印のとおりに入力してください。",
        "brands.buffet-pro.note": "表はadams-music.shopによるもので、shopforbandおよびGranlundと一致します（出典の誤植2か所を修正済み）。Buffetの1946〜57年と1964〜66年の記録は失われているため、これらの期間は年間約3,000本として推定しています。1961年の終わりが68,717か69,717かは出典によって異なります。1962年はどちらの場合も69,718から始まり、この表では見解が分かれる1,000番分を1961年として扱っています。公開されている表は439,774（1997年）までです。これより大きい番号は1998年以降です。",
        "brands.buffet-pro.caveats.0.html": "<strong>記録の消失：</strong>Buffetの1946〜1957年の帳簿は残っていません。表示している期間は、前後の年から年間約3,000本として推定したもので、製造工場の記録による日付ではありません。",
        "brands.buffet-pro.caveats.1.html": "<strong>記録の消失：</strong>Buffetの1964〜1966年の帳簿は残っていません。表示している期間は推定で、製造工場の記録による日付ではありません。",
        "brands.buffet-pro.caveats.2.html": "<strong>見解が分かれる1,000番分：</strong>公開されている表では、1961年の終わりが68,717か69,717かで見解が分かれています。この番号は1961年として扱っています。1962年はどの出典でも69,718から始まります。",
        "brands.buffet-pro.caveats.3.html": "<strong>公開されている表の範囲外：</strong>公開されているBuffetの一覧は、どれも439,774（1997年）で終わっています。これより大きい番号は1998年以降です。刻印とケースの形から時期を絞り込めます。写真をお送りいただければ拝見します：<a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "brands.buffet-e13.note": "E13の番号はadams-music.shopによるもので、出典は1つだけです。各年の最初のシリアルナンバーとして示されています。E13の連番はプロフェッショナル・ラインの連番と数字の範囲が重なるため、最初にラインを選んでいただきます。",
        "brands.buffet-harmony.note": "ハーモニー（E♭、アルト、バス、コントラ）の番号はadams-music.shopによるもので、出典は1つだけです。連番は1950年の19,506から始まり、年間数十本から数百本のペースで進みます。",
        "brands.buffet-student.noChart": "<strong>これらのモデルには公開された表がありません。</strong>E11、E12、B10、B12と、ドイツの刻印があるEvetteのクラリネットは、ドイツのSchreiberがSchreiber独自の番号で製造したもので、年ごとの一覧は公開されていません。製造時期について意見をお求めの場合は、上管と下管の刻印の写真を <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> までメールでお送りください。",
        "models.buffet-pro.0": "R13以前",
        "models.buffet-pro.1": "最初期のR13（報告されている最小の番号は45,451。R13の名称は1955年に採用）",
        "models.buffet-pro.2": "R13系（ポリシリンドリカル・ボア）。RC、Festival、Prestige、Vintage、Tosca、Divineも同じ連番を使用",
        "facts.buffet-pro.0": "シリアルナンバーの前にFがある楽器は、ヨーロッパのオーケストラ向けにA=442〜444で製造されたものです",
        "facts.buffet-pro.1": "報告されている最小のR13のシリアルナンバーは45,451（1953年）です。R13の名称は1955年に採用されました",
        "facts.buffet-pro.2": "61,000前後でポリシリンドリカル・ボアが導入され、現在知られているR13になります",
        "facts.buffet-pro.3": "公開されている年ごとの表は439,774（1997年）で終わっています。それ以降のシリアルナンバーは、出典が見つかるまで年ではなく時期で示します"
      }
    },
    ko: {
      copy: {
        "placeholder": "예: 157738, 1K630",
        "soldEmpty": "현재 판매 중인 상품과 판매 완료 아카이브에 비슷한 클라리넷이 없습니다. <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>으로 이메일을 보내 주시면 가지고 계신 클라리넷을 확인해 드리겠습니다."
      },
      s: {
        "sn.label": "시리얼 번호 입력",
        "nudge.brand": "<strong>거의 다 되었습니다:</strong> 위에서 클라리넷 라인을 선택하면 시리얼 번호 <strong>{0}</strong>의 제조 연도를 확인할 수 있습니다.",
        "prompt.empty": "<em>클라리넷에 각인된 시리얼 번호를 입력하십시오.</em>",
        "result.yearLabel": "제조 연도",
        "result.model": "<strong>추정 모델:</strong> {0}",
        "result.letteredNoMatch": "<strong>일치하는 항목 없음:</strong> 이 알파벳이 들어간 각인은 공개된 1885~1927년 표에 없습니다 (이 표에는 작은 누락이 있습니다). 클라리넷의 알파벳과 숫자를 확인하십시오. 그래도 일치하지 않으면 각인 사진을 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>으로 이메일로 보내 주십시오.",
        "result.masked": "<strong>거의 다 되었습니다:</strong> 시리얼 번호의 일부가 가려져 있거나 읽을 수 없습니다 (“xxx” 부분). 시리얼 번호는 상관에 각인되어 있고, 보통 하관, 배럴, 벨에도 있습니다. 각인된 숫자를 모두 입력하십시오.",
        "result.unparsed": "<em>하나의 시리얼 번호로 읽을 수 없습니다. 클라리넷에 각인된 숫자만 입력하십시오.</em>",
        "result.noMatch": "<strong>일치하는 항목 없음:</strong> 이 번호는 기록된 {0} 시리얼 번호 범위에 들어가지 않습니다. 클라리넷의 숫자를 다시 확인하십시오. 그래도 일치하지 않으면 사진을 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>으로 이메일로 보내 주십시오. 확인해 드리겠습니다.",
        "year.plain": "{0}년",
        "year.range": "{0}~{1}년",
        "year.orLater": "{0}년 이후",
        "year.approx": "{0}경",
        "chart.title": "{0} 시리얼 번호표에서 가지고 계신 클라리넷의 위치",
        "chart.th.serial": "시리얼 번호",
        "chart.th.year": "제조 연도",
        "chart.th.model": "모델 시기",
        "chart.lettered": "알파벳이 붙은 시리얼 번호",
        "chart.andUp": "{0} 이상",
        "save.sheet": "열린 메뉴에서 <strong>북마크 추가</strong> 또는 <strong>홈 화면에 추가</strong>를 선택하십시오.",
        "save.tap": "브라우저의 공유 아이콘을 누른 다음 <strong>북마크 추가</strong>를 선택하십시오.",
        "save.press": "<strong>{0}</strong> 키를 누르면 이 페이지를 북마크할 수 있습니다.",
        "save.copied": "링크를 복사했습니다.",
        "save.copyThis": "이 링크를 복사하십시오: <strong>{0}</strong>",
        "sold.loading": "판매 중인 상품과 판매 완료 아카이브를 찾고 있습니다…",
        "sold.badge": "판매 완료",
        "brands.buffet-pro.name": "프로페셔널 라인 (R13 계열)",
        "brands.buffet-e13.name": "E13 (프랑스제 중급 모델)",
        "brands.buffet-harmony.name": "하모니 클라리넷 (E♭, 알토, 베이스, 콘트라)",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12 (입문자, 학생용)",
        "brands.buffet-pro.sections.0.label": "1928년 이후 숫자만 있는 시리얼 번호 (R13 이전 모델, R13, RC, Festival, Prestige, Vintage, Tosca, Divine이 하나의 일련번호 사용)",
        "brands.buffet-e13.sections.0.label": "E13 (자체 일련번호)",
        "brands.buffet-harmony.sections.0.label": "하모니 클라리넷 (자체 일련번호)",
        "brands.buffet-pro.letteredLabel": "1885~1927년의 알파벳이 붙은 시리얼 번호 (1K630, 498A처럼 알파벳과 숫자의 조합)",
        "brands.buffet-pro.letteredModel": "R13 이전 (알파벳 시리얼 시대)",
        "brands.buffet-pro.letteredNote": "알파벳이 붙은 각인은 숫자 앞이나 뒤에 알파벳이 있습니다. 1908년부터는 알파벳 앞에 숫자가 한 자리 더 붙습니다. 각인된 그대로 입력하십시오.",
        "brands.buffet-pro.note": "표는 adams-music.shop의 것이며, shopforband 및 Granlund와 일치합니다 (출처의 오타 두 곳을 수정). Buffet의 1946~57년과 1964~66년 기록은 사라졌기 때문에, 이 기간은 연간 약 3,000대로 추정했습니다. 1961년의 끝이 68,717인지 69,717인지는 출처마다 다릅니다. 1962년은 어느 쪽이든 69,718부터 시작하며, 이 표에서는 의견이 갈리는 1,000번을 1961년으로 봅니다. 공개된 표는 439,774 (1997년)까지입니다. 그보다 큰 번호는 1998년 이후입니다.",
        "brands.buffet-pro.caveats.0.html": "<strong>기록 소실:</strong> Buffet의 1946~1957년 장부는 남아 있지 않습니다. 표시된 기간은 앞뒤 연도로부터 연간 약 3,000대로 추정한 것이며, 공장 기록에 따른 날짜가 아닙니다.",
        "brands.buffet-pro.caveats.1.html": "<strong>기록 소실:</strong> Buffet의 1964~1966년 장부는 남아 있지 않습니다. 표시된 기간은 추정치이며, 공장 기록에 따른 날짜가 아닙니다.",
        "brands.buffet-pro.caveats.2.html": "<strong>의견이 갈리는 1,000번:</strong> 공개된 표들은 1961년의 끝이 68,717인지 69,717인지에 대해 의견이 다릅니다. 이 번호는 1961년으로 봅니다. 1962년은 모든 출처에서 69,718부터 시작합니다.",
        "brands.buffet-pro.caveats.3.html": "<strong>공개된 표의 범위 밖:</strong> 공개된 Buffet 목록은 모두 439,774 (1997년)에서 끝납니다. 그보다 큰 번호는 1998년 이후입니다. 각인과 케이스 형태로 시기를 좁힐 수 있습니다. 사진을 보내 주시면 확인해 드리겠습니다: <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "brands.buffet-e13.note": "E13 번호는 adams-music.shop의 것으로, 자료는 하나뿐입니다. 각 연도의 첫 시리얼 번호로 표시되어 있습니다. E13 일련번호는 프로페셔널 라인 일련번호와 숫자 범위가 겹치기 때문에 라인을 먼저 선택하도록 했습니다.",
        "brands.buffet-harmony.note": "하모니 (E♭, 알토, 베이스, 콘트라) 번호는 adams-music.shop의 것으로, 자료는 하나뿐입니다. 일련번호는 1950년의 19,506부터 시작하며, 연간 수십 대에서 수백 대씩 늘어납니다.",
        "brands.buffet-student.noChart": "<strong>이 모델들에는 공개된 표가 없습니다.</strong> E11, E12, B10, B12와 독일 각인이 있는 Evette 클라리넷은 독일의 Schreiber가 자체 번호 체계로 제조했으며, 연도별 목록은 공개되지 않았습니다. 제조 시기에 대한 의견을 원하시면 상관과 하관의 각인 사진을 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>으로 이메일로 보내 주십시오.",
        "models.buffet-pro.0": "R13 이전",
        "models.buffet-pro.1": "최초기 R13 (보고된 가장 작은 번호는 45,451. R13이라는 이름은 1955년에 채택)",
        "models.buffet-pro.2": "R13 계열 (폴리실린드리컬 보어). RC, Festival, Prestige, Vintage, Tosca, Divine도 같은 일련번호 사용",
        "facts.buffet-pro.0": "시리얼 번호 앞에 F가 있는 악기는 유럽 오케스트라용으로 A=442~444에 맞춰 제조된 것입니다",
        "facts.buffet-pro.1": "보고된 가장 작은 R13 시리얼 번호는 45,451 (1953년)입니다. R13이라는 이름은 1955년에 채택되었습니다",
        "facts.buffet-pro.2": "61,000 전후에 폴리실린드리컬 보어가 도입되어, 오늘날 연주자들이 아는 R13이 됩니다",
        "facts.buffet-pro.3": "공개된 연도별 표는 439,774 (1997년)에서 끝납니다. 그 이후의 시리얼 번호는 출처가 확인될 때까지 연도가 아니라 시기로 표시합니다"
      }
    },
    es: {
      "copy": {
        "placeholder": "p. ej. 157738 o 1K630",
        "soldEmpty": "Ahora no hay nada parecido a la venta ni en nuestro archivo de vendidos. Escribe a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> y revisaremos tu clarinete."
      },
      "s": {
        "sn.label": "Escribe el número de serie",
        "nudge.brand": "<strong>Ya casi:</strong> elige arriba la línea de tu clarinete para fechar el número de serie <strong>{0}</strong>.",
        "prompt.empty": "<em>Escribe el número de serie grabado en tu clarinete.</em>",
        "result.yearLabel": "Año de fabricación",
        "result.model": "<strong>Modelo estimado:</strong> {0}",
        "result.letteredNoMatch": "<strong>Sin coincidencia:</strong> esa marca con letra no está en la tabla publicada de 1885-1927, que tiene pequeños huecos. Revisa la letra y los dígitos del clarinete. Si sigue sin coincidir, envía una foto de la marca a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "result.masked": "<strong>Ya casi:</strong> parte de ese número de serie parece oculta o ilegible (la “xxx”). Busca el número completo grabado en el clarinete. Está en el cuerpo superior y por lo general también en el cuerpo inferior, el barrilete y la campana. Escribe todos los dígitos.",
        "result.unparsed": "<em>Eso no parece un solo número de serie. Escribe solo los dígitos grabados en el clarinete.</em>",
        "result.noMatch": "<strong>Sin coincidencia:</strong> ese número queda fuera de los rangos de números de serie documentados de {0}. Revisa los dígitos del clarinete. Si sigue sin coincidir, envía una foto a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> y la revisaremos.",
        "year.plain": "{0}",
        "year.range": "{0}-{1}",
        "year.orLater": "{0} o después",
        "year.approx": "hacia {0}",
        "chart.title": "Dónde queda tu clarinete en la tabla de números de serie de {0}",
        "chart.th.serial": "Números de serie",
        "chart.th.year": "Año",
        "chart.th.model": "Época del modelo",
        "chart.lettered": "Números de serie con letra",
        "chart.andUp": "{0} en adelante",
        "save.sheet": "Elige <strong>Agregar marcador</strong> o <strong>Agregar a pantalla de inicio</strong> en el menú que se abrió.",
        "save.tap": "Toca el ícono de compartir de tu navegador y después <strong>Agregar marcador</strong>.",
        "save.press": "Presiona <strong>{0}</strong> para guardar esta página en tus marcadores.",
        "save.copied": "Enlace copiado.",
        "save.copyThis": "Copia este enlace: <strong>{0}</strong>",
        "sold.loading": "Buscando en nuestros anuncios y en el archivo de vendidos…",
        "sold.badge": "VENDIDO",
        "brands.buffet-pro.name": "Línea profesional (R13 y sus modelos relacionados)",
        "brands.buffet-e13.name": "E13 (intermedio francés)",
        "brands.buffet-harmony.name": "Clarinetes Harmony (Mi bemol, alto, bajo, contrabajo)",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12 (estudiante)",
        "brands.buffet-pro.sections.0.label": "Números de serie numéricos desde 1928 (una sola numeración para los anteriores al R13, R13, RC, Festival, Prestige, Vintage, Tosca, Divine)",
        "brands.buffet-e13.sections.0.label": "E13, numeración propia",
        "brands.buffet-harmony.sections.0.label": "Clarinetes Harmony, numeración propia",
        "brands.buffet-pro.letteredLabel": "Números de serie con letra 1885-1927 (una letra con un número, como 1K630 o 498A)",
        "brands.buffet-pro.letteredModel": "Anterior al R13 (época de números con letra)",
        "brands.buffet-pro.letteredNote": "Las marcas con letra llevan una letra antes o después del número, y desde 1908 un dígito delante de la letra. Escríbelo tal como está grabado.",
        "brands.buffet-pro.note": "Tablas según adams-music.shop, que coinciden con shopforband y Granlund (se corrigieron dos erratas de las fuentes). Los registros de Buffet de 1946-57 y 1964-66 se perdieron, así que esos tramos son estimaciones de unos 3,000 instrumentos por año. Las fuentes no coinciden en si 1961 termina en 68,717 o en 69,717. En ambos casos 1962 empieza en 69,718, y la tabla asigna a 1961 el millar en disputa. Las tablas públicas terminan en 439,774 (1997). Un número mayor es de 1998 o posterior.",
        "brands.buffet-pro.caveats.0.html": "<strong>Registros perdidos:</strong> los libros de Buffet de 1946 a 1957 no se conservaron. El tramo que se muestra es una estimación a partir de los años cercanos, de unos 3,000 instrumentos por año, no una fecha de fábrica.",
        "brands.buffet-pro.caveats.1.html": "<strong>Registros perdidos:</strong> los libros de Buffet de 1964 a 1966 no se conservaron. El tramo que se muestra es una estimación, no una fecha de fábrica.",
        "brands.buffet-pro.caveats.2.html": "<strong>Millar en disputa:</strong> las tablas publicadas no coinciden en si 1961 termina en 68,717 o en 69,717. Este número se asigna a 1961. En todas las fuentes 1962 empieza en 69,718.",
        "brands.buffet-pro.caveats.3.html": "<strong>Fuera de las tablas públicas:</strong> todas las listas publicadas de Buffet terminan en 439,774 (1997). Un número mayor es de 1998 o posterior. La marca y el tipo de estuche reducen el rango. Con gusto revisamos una foto: <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "brands.buffet-e13.note": "Números del E13 según adams-music.shop, una sola fuente, dados como el número de serie al inicio de cada año listado. La numeración del E13 queda dentro del rango numérico de la numeración profesional. Por eso primero se elige la línea.",
        "brands.buffet-harmony.note": "Números de Harmony (Mi bemol, alto, bajo y contrabajo) según adams-music.shop, una sola fuente. La numeración empieza en 19,506 en 1950 y avanza de unas pocas docenas a unos pocos cientos de instrumentos por año.",
        "brands.buffet-student.noChart": "<strong>No existe una tabla pública para estos modelos.</strong> Los clarinetes E11, E12, B10, B12 y Evette con marca alemana los fabricó Schreiber en Alemania con su propia numeración, y no se ha publicado una lista por año. Si quieres una opinión sobre la antigüedad, envía una foto de las marcas de los dos cuerpos a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "models.buffet-pro.0": "Anterior al R13",
        "models.buffet-pro.1": "Primeros R13 (el más bajo reportado es 45,451; el nombre se adoptó en 1955)",
        "models.buffet-pro.2": "Familia R13 (tubo policilíndrico). RC, Festival, Prestige, Vintage, Tosca y Divine comparten la numeración",
        "facts.buffet-pro.0": "Una F delante del número de serie indica que el instrumento se fabricó en La=442-444 para orquestas europeas",
        "facts.buffet-pro.1": "El número de serie de R13 más bajo reportado es 45,451 (1953). El nombre R13 se adoptó en 1955",
        "facts.buffet-pro.2": "El tubo policilíndrico llega hacia el 61,000, y con él el R13 que conocen los músicos",
        "facts.buffet-pro.3": "Las tablas públicas por año terminan en 439,774 (1997). Los números de serie posteriores reciben una época, no un año, hasta encontrar una fuente"
      }
    },
    de: {
      "copy": {
        "placeholder": "z. B. 157738 oder 1K630",
        "soldEmpty": "Derzeit gibt es nichts Ähnliches im Angebot oder in unserem Archiv verkaufter Instrumente. Schreiben Sie an <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>, und wir sehen uns Ihre Klarinette an."
      },
      "s": {
        "sn.label": "Seriennummer eingeben",
        "nudge.brand": "<strong>Fast geschafft:</strong> Wählen Sie oben die Modelllinie Ihrer Klarinette, um die Seriennummer <strong>{0}</strong> zu datieren.",
        "prompt.empty": "<em>Geben Sie die Seriennummer ein, die auf Ihrer Klarinette eingraviert ist.</em>",
        "result.yearLabel": "Baujahr",
        "result.model": "<strong>Geschätztes Modell:</strong> {0}",
        "result.letteredNoMatch": "<strong>Keine Übereinstimmung:</strong> Diese Prägung mit Buchstaben steht nicht in der veröffentlichten Tabelle von 1885-1927, die kleine Lücken hat. Prüfen Sie Buchstaben und Ziffern auf der Klarinette. Wenn es weiterhin nicht passt, senden Sie ein Foto der Prägung an <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "result.masked": "<strong>Fast geschafft:</strong> Ein Teil dieser Seriennummer scheint verdeckt oder unleserlich zu sein (das „xxx“). Suchen Sie die vollständige Nummer, die auf der Klarinette eingraviert ist. Sie steht auf dem Oberstück und meist auch auf dem Unterstück, der Birne und dem Becher. Geben Sie alle Ziffern ein.",
        "result.unparsed": "<em>Das sieht nicht wie eine einzelne Seriennummer aus. Geben Sie nur die Ziffern ein, die auf der Klarinette eingraviert sind.</em>",
        "result.noMatch": "<strong>Keine Übereinstimmung:</strong> Diese Nummer liegt außerhalb der dokumentierten Seriennummernbereiche von {0}. Prüfen Sie die Ziffern auf der Klarinette. Wenn es weiterhin nicht passt, senden Sie ein Foto an <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>, und wir sehen es uns an.",
        "year.plain": "{0}",
        "year.range": "{0}-{1}",
        "year.orLater": "{0} oder später",
        "year.approx": "um {0}",
        "chart.title": "Wo Ihre Klarinette in der Seriennummerntabelle von {0} liegt",
        "chart.th.serial": "Seriennummern",
        "chart.th.year": "Jahr",
        "chart.th.model": "Modellepoche",
        "chart.lettered": "Seriennummern mit Buchstaben",
        "chart.andUp": "ab {0}",
        "save.sheet": "Wählen Sie im geöffneten Menü <strong>Lesezeichen hinzufügen</strong> oder <strong>Zum Home-Bildschirm</strong>.",
        "save.tap": "Tippen Sie auf das Teilen-Symbol Ihres Browsers und dann auf <strong>Lesezeichen hinzufügen</strong>.",
        "save.press": "Drücken Sie <strong>{0}</strong>, um diese Seite als Lesezeichen zu speichern.",
        "save.copied": "Link kopiert.",
        "save.copyThis": "Kopieren Sie diesen Link: <strong>{0}</strong>",
        "sold.loading": "Suche in unseren Angeboten und im Archiv verkaufter Instrumente…",
        "sold.badge": "VERKAUFT",
        "brands.buffet-pro.name": "Profi-Linie (R13 und verwandte Modelle)",
        "brands.buffet-e13.name": "E13 (französisches Mittelklassemodell)",
        "brands.buffet-harmony.name": "Harmony-Klarinetten (Es, Alt, Bass, Kontrabass)",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12 (Schülermodelle)",
        "brands.buffet-pro.sections.0.label": "Numerische Seriennummern ab 1928 (eine Nummernfolge für Modelle vor dem R13, R13, RC, Festival, Prestige, Vintage, Tosca, Divine)",
        "brands.buffet-e13.sections.0.label": "E13, eigene Nummernfolge",
        "brands.buffet-harmony.sections.0.label": "Harmony-Klarinetten, eigene Nummernfolge",
        "brands.buffet-pro.letteredLabel": "Seriennummern mit Buchstaben 1885-1927 (ein Buchstabe mit einer Nummer, wie 1K630 oder 498A)",
        "brands.buffet-pro.letteredModel": "Vor dem R13 (Epoche der Nummern mit Buchstaben)",
        "brands.buffet-pro.letteredNote": "Prägungen mit Buchstaben haben einen Buchstaben vor oder nach der Nummer, ab 1908 außerdem eine Ziffer vor dem Buchstaben. Geben Sie die Nummer so ein, wie sie eingraviert ist.",
        "brands.buffet-pro.note": "Tabellen nach adams-music.shop, übereinstimmend mit shopforband und Granlund (zwei Tippfehler der Quellen wurden korrigiert). Die Buffet-Unterlagen von 1946-57 und 1964-66 sind verloren. Diese Abschnitte sind daher Schätzungen von etwa 3,000 Instrumenten pro Jahr. Die Quellen sind sich nicht einig, ob 1961 bei 68,717 oder bei 69,717 endet. In beiden Fällen beginnt 1962 bei 69,718, und die Tabelle ordnet das strittige Tausend 1961 zu. Die öffentlichen Tabellen enden bei 439,774 (1997). Eine höhere Nummer ist von 1998 oder später.",
        "brands.buffet-pro.caveats.0.html": "<strong>Verlorene Unterlagen:</strong> Die Buffet-Bücher von 1946 bis 1957 sind nicht erhalten. Der angezeigte Abschnitt ist eine Schätzung aus den benachbarten Jahren, etwa 3,000 Instrumente pro Jahr, kein Werksdatum.",
        "brands.buffet-pro.caveats.1.html": "<strong>Verlorene Unterlagen:</strong> Die Buffet-Bücher von 1964 bis 1966 sind nicht erhalten. Der angezeigte Abschnitt ist eine Schätzung, kein Werksdatum.",
        "brands.buffet-pro.caveats.2.html": "<strong>Strittiges Tausend:</strong> Die veröffentlichten Tabellen sind sich nicht einig, ob 1961 bei 68,717 oder bei 69,717 endet. Diese Nummer wird 1961 zugeordnet. In allen Quellen beginnt 1962 bei 69,718.",
        "brands.buffet-pro.caveats.3.html": "<strong>Außerhalb der öffentlichen Tabellen:</strong> Alle veröffentlichten Buffet-Listen enden bei 439,774 (1997). Eine höhere Nummer ist von 1998 oder später. Die Prägung und die Art des Koffers grenzen den Bereich ein. Wir sehen uns gern ein Foto an: <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "brands.buffet-e13.note": "E13-Nummern nach adams-music.shop, eine einzige Quelle, angegeben als Seriennummer zu Beginn jedes aufgeführten Jahres. Die Nummernfolge des E13 liegt innerhalb des Zahlenbereichs der Profi-Nummernfolge. Deshalb wählen Sie zuerst die Modelllinie.",
        "brands.buffet-harmony.note": "Harmony-Nummern (Es, Alt, Bass und Kontrabass) nach adams-music.shop, eine einzige Quelle. Die Nummernfolge beginnt 1950 bei 19,506 und steigt um einige Dutzend bis einige Hundert Instrumente pro Jahr.",
        "brands.buffet-student.noChart": "<strong>Für diese Modelle gibt es keine öffentliche Tabelle.</strong> Die Klarinetten E11, E12, B10, B12 und Evette mit deutscher Prägung wurden von Schreiber in Deutschland mit eigener Nummernfolge gebaut, und eine Liste nach Jahren wurde nicht veröffentlicht. Wenn Sie eine Einschätzung des Alters möchten, senden Sie ein Foto der Prägungen auf beiden Korpusteilen an <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "models.buffet-pro.0": "Vor dem R13",
        "models.buffet-pro.1": "Frühe R13 (die niedrigste gemeldete Nummer ist 45,451; der Name wurde 1955 eingeführt)",
        "models.buffet-pro.2": "R13-Familie (polyzylindrische Bohrung). RC, Festival, Prestige, Vintage, Tosca und Divine teilen die Nummernfolge",
        "facts.buffet-pro.0": "Ein F vor der Seriennummer bedeutet, dass das Instrument in A=442-444 für europäische Orchester gebaut wurde",
        "facts.buffet-pro.1": "Die niedrigste gemeldete R13-Seriennummer ist 45,451 (1953). Der Name R13 wurde 1955 eingeführt",
        "facts.buffet-pro.2": "Die polyzylindrische Bohrung kommt um 61,000, und mit ihr das R13, das Musiker kennen",
        "facts.buffet-pro.3": "Die öffentlichen Jahrestabellen enden bei 439,774 (1997). Spätere Seriennummern erhalten eine Epoche, kein Jahr, bis eine Quelle gefunden ist"
      }
    },
    it: {
      "copy": {
        "placeholder": "es. 157738 o 1K630",
        "soldEmpty": "Al momento non c'è niente di simile in vendita né nel nostro archivio dei venduti. Scrivi a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> e daremo un'occhiata al tuo clarinetto."
      },
      "s": {
        "sn.label": "Inserisci il numero di serie",
        "nudge.brand": "<strong>Quasi fatto:</strong> scegli qui sopra la linea del tuo clarinetto per datare il numero di serie <strong>{0}</strong>.",
        "prompt.empty": "<em>Inserisci il numero di serie inciso sul tuo clarinetto.</em>",
        "result.yearLabel": "Anno di fabbricazione",
        "result.model": "<strong>Modello stimato:</strong> {0}",
        "result.letteredNoMatch": "<strong>Nessuna corrispondenza:</strong> quella marcatura con lettera non è nella tabella pubblicata 1885-1927, che ha piccole lacune. Controlla la lettera e le cifre sul clarinetto. Se ancora non corrisponde, invia una foto della marcatura a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "result.masked": "<strong>Quasi fatto:</strong> parte di quel numero di serie sembra nascosta o illeggibile (la “xxx”). Cerca il numero completo inciso sul clarinetto. Si trova sul corpo superiore e di solito anche sul corpo inferiore, sul barilotto e sulla campana. Inserisci tutte le cifre.",
        "result.unparsed": "<em>Questo non sembra un singolo numero di serie. Inserisci solo le cifre incise sul clarinetto.</em>",
        "result.noMatch": "<strong>Nessuna corrispondenza:</strong> quel numero è fuori dagli intervalli di numeri di serie documentati di {0}. Controlla le cifre sul clarinetto. Se ancora non corrisponde, invia una foto a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> e la controlleremo.",
        "year.plain": "{0}",
        "year.range": "{0}-{1}",
        "year.orLater": "{0} o successivo",
        "year.approx": "circa {0}",
        "chart.title": "Dove si colloca il tuo clarinetto nella tabella dei numeri di serie {0}",
        "chart.th.serial": "Numeri di serie",
        "chart.th.year": "Anno",
        "chart.th.model": "Epoca del modello",
        "chart.lettered": "Numeri di serie con lettera",
        "chart.andUp": "{0} e oltre",
        "save.sheet": "Scegli <strong>Aggiungi segnalibro</strong> o <strong>Aggiungi alla schermata Home</strong> nel menu che si è aperto.",
        "save.tap": "Tocca l'icona di condivisione del browser e poi <strong>Aggiungi segnalibro</strong>.",
        "save.press": "Premi <strong>{0}</strong> per salvare questa pagina nei segnalibri.",
        "save.copied": "Link copiato.",
        "save.copyThis": "Copia questo link: <strong>{0}</strong>",
        "sold.loading": "Ricerca negli annunci e nell'archivio dei venduti…",
        "sold.badge": "VENDUTO",
        "brands.buffet-pro.name": "Linea professionale (R13 e modelli collegati)",
        "brands.buffet-e13.name": "E13 (intermedio francese)",
        "brands.buffet-harmony.name": "Clarinetti Harmony (Mi bemolle, contralto, basso, contrabbasso)",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12 (studio)",
        "brands.buffet-pro.sections.0.label": "Numeri di serie numerici dal 1928 (un'unica numerazione per i modelli precedenti all'R13, R13, RC, Festival, Prestige, Vintage, Tosca, Divine)",
        "brands.buffet-e13.sections.0.label": "E13, numerazione propria",
        "brands.buffet-harmony.sections.0.label": "Clarinetti Harmony, numerazione propria",
        "brands.buffet-pro.letteredLabel": "Numeri di serie con lettera 1885-1927 (una lettera con un numero, come 1K630 o 498A)",
        "brands.buffet-pro.letteredModel": "Precedente all'R13 (epoca dei numeri con lettera)",
        "brands.buffet-pro.letteredNote": "Le marcature con lettera hanno una lettera prima o dopo il numero, e dal 1908 una cifra davanti alla lettera. Inseriscilo come è inciso.",
        "brands.buffet-pro.note": "Tabelle secondo adams-music.shop, che coincidono con shopforband e Granlund (sono stati corretti due refusi delle fonti). I registri Buffet del 1946-57 e del 1964-66 sono andati perduti, quindi quei tratti sono stime di circa 3,000 strumenti all'anno. Le fonti non concordano se il 1961 termini a 68,717 o a 69,717. In entrambi i casi il 1962 inizia a 69,718, e la tabella assegna al 1961 il migliaio conteso. Le tabelle pubbliche terminano a 439,774 (1997). Un numero più alto è del 1998 o successivo.",
        "brands.buffet-pro.caveats.0.html": "<strong>Registri perduti:</strong> i registri Buffet dal 1946 al 1957 non si sono conservati. Il tratto indicato è una stima basata sugli anni vicini, di circa 3,000 strumenti all'anno, non una data di fabbrica.",
        "brands.buffet-pro.caveats.1.html": "<strong>Registri perduti:</strong> i registri Buffet dal 1964 al 1966 non si sono conservati. Il tratto indicato è una stima, non una data di fabbrica.",
        "brands.buffet-pro.caveats.2.html": "<strong>Migliaio conteso:</strong> le tabelle pubblicate non concordano se il 1961 termini a 68,717 o a 69,717. Questo numero è assegnato al 1961. In tutte le fonti il 1962 inizia a 69,718.",
        "brands.buffet-pro.caveats.3.html": "<strong>Oltre le tabelle pubbliche:</strong> tutti gli elenchi Buffet pubblicati terminano a 439,774 (1997). Un numero più alto è del 1998 o successivo. La marcatura e il tipo di custodia restringono l'intervallo. Controlliamo volentieri una foto: <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "brands.buffet-e13.note": "Numeri dell'E13 secondo adams-music.shop, un'unica fonte, indicati come il numero di serie all'inizio di ogni anno in elenco. La numerazione dell'E13 rientra nell'intervallo numerico della numerazione professionale. Per questo si sceglie prima la linea.",
        "brands.buffet-harmony.note": "Numeri Harmony (Mi bemolle, contralto, basso e contrabbasso) secondo adams-music.shop, un'unica fonte. La numerazione inizia a 19,506 nel 1950 e avanza da qualche decina a qualche centinaio di strumenti all'anno.",
        "brands.buffet-student.noChart": "<strong>Non esiste una tabella pubblica per questi modelli.</strong> I clarinetti E11, E12, B10, B12 ed Evette con marcatura tedesca sono stati costruiti da Schreiber in Germania con una numerazione propria, e non è stato pubblicato un elenco per anno. Se vuoi un parere sull'età, invia una foto delle marcature dei due corpi a <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "models.buffet-pro.0": "Precedente all'R13",
        "models.buffet-pro.1": "Primi R13 (il più basso segnalato è 45,451; il nome fu adottato nel 1955)",
        "models.buffet-pro.2": "Famiglia R13 (canneggio policilindrico). RC, Festival, Prestige, Vintage, Tosca e Divine condividono la numerazione",
        "facts.buffet-pro.0": "Una F davanti al numero di serie indica che lo strumento è stato costruito in La=442-444 per le orchestre europee",
        "facts.buffet-pro.1": "Il numero di serie R13 più basso segnalato è 45,451 (1953). Il nome R13 fu adottato nel 1955",
        "facts.buffet-pro.2": "Il canneggio policilindrico arriva intorno a 61,000, e con esso l'R13 che i musicisti conoscono",
        "facts.buffet-pro.3": "Le tabelle pubbliche per anno terminano a 439,774 (1997). I numeri di serie successivi ricevono un'epoca, non un anno, finché non si trova una fonte"
      }
    },
    fr: {
      "copy": {
        "placeholder": "p. ex. 157738 ou 1K630",
        "soldEmpty": "Rien de semblable en vente ni dans nos archives de ventes pour le moment. Écrivez à <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> et nous examinerons votre clarinette."
      },
      "s": {
        "sn.label": "Saisissez le numéro de série",
        "nudge.brand": "<strong>Presque fini :</strong> choisissez ci-dessus la gamme de votre clarinette pour dater le numéro de série <strong>{0}</strong>.",
        "prompt.empty": "<em>Saisissez le numéro de série gravé sur votre clarinette.</em>",
        "result.yearLabel": "Année de fabrication",
        "result.model": "<strong>Modèle estimé :</strong> {0}",
        "result.letteredNoMatch": "<strong>Aucune correspondance :</strong> cette marque avec lettre ne figure pas dans le tableau publié de 1885-1927, qui comporte de petites lacunes. Vérifiez la lettre et les chiffres sur la clarinette. Si cela ne correspond toujours pas, envoyez une photo de la marque à <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "result.masked": "<strong>Presque fini :</strong> une partie de ce numéro de série semble masquée ou illisible (le « xxx »). Cherchez le numéro complet gravé sur la clarinette. Il se trouve sur le corps du haut et en général aussi sur le corps du bas, le baril et le pavillon. Saisissez tous les chiffres.",
        "result.unparsed": "<em>Cela ne ressemble pas à un seul numéro de série. Saisissez seulement les chiffres gravés sur la clarinette.</em>",
        "result.noMatch": "<strong>Aucune correspondance :</strong> ce numéro se trouve hors des plages de numéros de série documentées pour {0}. Vérifiez les chiffres sur la clarinette. Si cela ne correspond toujours pas, envoyez une photo à <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a> et nous l'examinerons.",
        "year.plain": "{0}",
        "year.range": "{0}-{1}",
        "year.orLater": "{0} ou plus tard",
        "year.approx": "vers {0}",
        "chart.title": "Où se situe votre clarinette dans le tableau des numéros de série {0}",
        "chart.th.serial": "Numéros de série",
        "chart.th.year": "Année",
        "chart.th.model": "Époque du modèle",
        "chart.lettered": "Numéros de série avec lettre",
        "chart.andUp": "{0} et après",
        "save.sheet": "Choisissez <strong>Ajouter un signet</strong> ou <strong>Sur l'écran d'accueil</strong> dans le menu qui s'est ouvert.",
        "save.tap": "Touchez l'icône de partage de votre navigateur, puis <strong>Ajouter un signet</strong>.",
        "save.press": "Appuyez sur <strong>{0}</strong> pour ajouter cette page à vos favoris.",
        "save.copied": "Lien copié.",
        "save.copyThis": "Copiez ce lien : <strong>{0}</strong>",
        "sold.loading": "Recherche dans nos annonces et dans les archives de ventes…",
        "sold.badge": "VENDU",
        "brands.buffet-pro.name": "Gamme professionnelle (R13 et modèles apparentés)",
        "brands.buffet-e13.name": "E13 (intermédiaire français)",
        "brands.buffet-harmony.name": "Clarinettes Harmony (mi bémol, alto, basse, contrebasse)",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12 (étude)",
        "brands.buffet-pro.sections.0.label": "Numéros de série numériques depuis 1928 (une seule numérotation pour les modèles antérieurs au R13, R13, RC, Festival, Prestige, Vintage, Tosca, Divine)",
        "brands.buffet-e13.sections.0.label": "E13, numérotation propre",
        "brands.buffet-harmony.sections.0.label": "Clarinettes Harmony, numérotation propre",
        "brands.buffet-pro.letteredLabel": "Numéros de série avec lettre 1885-1927 (une lettre avec un numéro, comme 1K630 ou 498A)",
        "brands.buffet-pro.letteredModel": "Antérieur au R13 (époque des numéros avec lettre)",
        "brands.buffet-pro.letteredNote": "Les marques avec lettre portent une lettre avant ou après le numéro, et depuis 1908 un chiffre devant la lettre. Saisissez-le tel qu'il est gravé.",
        "brands.buffet-pro.note": "Tableaux d'après adams-music.shop, qui concordent avec shopforband et Granlund (deux erreurs de saisie des sources ont été corrigées). Les registres Buffet de 1946-57 et de 1964-66 ont été perdus : ces tranches sont donc des estimations d'environ 3,000 instruments par an. Les sources ne s'accordent pas sur la fin de 1961, à 68,717 ou à 69,717. Dans les deux cas, 1962 commence à 69,718, et le tableau attribue à 1961 le millier contesté. Les tableaux publics s'arrêtent à 439,774 (1997). Un numéro plus élevé date de 1998 ou plus tard.",
        "brands.buffet-pro.caveats.0.html": "<strong>Registres perdus :</strong> les registres Buffet de 1946 à 1957 n'ont pas été conservés. La tranche affichée est une estimation à partir des années voisines, d'environ 3,000 instruments par an, et non une date d'usine.",
        "brands.buffet-pro.caveats.1.html": "<strong>Registres perdus :</strong> les registres Buffet de 1964 à 1966 n'ont pas été conservés. La tranche affichée est une estimation, et non une date d'usine.",
        "brands.buffet-pro.caveats.2.html": "<strong>Millier contesté :</strong> les tableaux publiés ne s'accordent pas sur la fin de 1961, à 68,717 ou à 69,717. Ce numéro est attribué à 1961. Dans toutes les sources, 1962 commence à 69,718.",
        "brands.buffet-pro.caveats.3.html": "<strong>Au-delà des tableaux publics :</strong> toutes les listes Buffet publiées s'arrêtent à 439,774 (1997). Un numéro plus élevé date de 1998 ou plus tard. La marque et le type d'étui réduisent la plage. Nous examinons volontiers une photo : <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "brands.buffet-e13.note": "Numéros du E13 d'après adams-music.shop, une source unique, donnés comme le numéro de série au début de chaque année listée. La numérotation du E13 se situe dans la plage numérique de la numérotation professionnelle. C'est pourquoi il faut d'abord choisir la gamme.",
        "brands.buffet-harmony.note": "Numéros Harmony (mi bémol, alto, basse et contrebasse) d'après adams-music.shop, une source unique. La numérotation commence à 19,506 en 1950 et avance de quelques dizaines à quelques centaines d'instruments par an.",
        "brands.buffet-student.noChart": "<strong>Il n'existe pas de tableau public pour ces modèles.</strong> Les clarinettes E11, E12, B10, B12 et Evette de marque allemande ont été fabriquées par Schreiber en Allemagne avec leur propre numérotation, et aucune liste par année n'a été publiée. Pour un avis sur l'âge, envoyez une photo des marques des deux corps à <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.",
        "models.buffet-pro.0": "Antérieur au R13",
        "models.buffet-pro.1": "Premiers R13 (le plus bas signalé est 45,451 ; le nom a été adopté en 1955)",
        "models.buffet-pro.2": "Famille R13 (perce polycylindrique). RC, Festival, Prestige, Vintage, Tosca et Divine partagent la numérotation",
        "facts.buffet-pro.0": "Un F devant le numéro de série indique que l'instrument a été fabriqué en la=442-444 pour les orchestres européens",
        "facts.buffet-pro.1": "Le numéro de série de R13 le plus bas signalé est 45,451 (1953). Le nom R13 a été adopté en 1955",
        "facts.buffet-pro.2": "La perce polycylindrique arrive vers 61,000, et avec elle le R13 que les musiciens connaissent",
        "facts.buffet-pro.3": "Les tableaux publics par année s'arrêtent à 439,774 (1997). Les numéros de série plus récents reçoivent une époque, pas une année, jusqu'à ce qu'une source soit trouvée"
      }
    },
    // DCSAX_ZH_START (built by tools/locale-zh/build.py from theme/staged-i18n-zh-2026-10-18)
    "zh-tw": {
      "copy": {
        "placeholder": "例如：157738、1K630",
        "soldEmpty": "目前在售商品和已售出檔案中，都沒有類似的單簧管。歡迎來信 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>，我們會看看您的單簧管。"
      },
      "s": {
        "sn.label": "輸入序號",
        "nudge.brand": "<strong>只差一步：</strong>在上方選擇單簧管的系列，就能查出序號 <strong>{0}</strong> 的製造年份。",
        "prompt.empty": "<em>請輸入單簧管上刻的序號。</em>",
        "result.yearLabel": "製造年份",
        "result.model": "<strong>推測型號：</strong>{0}",
        "result.letteredNoMatch": "<strong>查無資料：</strong>這個含字母的刻印不在公開的1885〜1927年表中（這份表有一些小缺口）。請核對單簧管上的字母和數字。如果仍然不符，請將刻印的照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "result.masked": "<strong>只差一步：</strong>序號似乎有一部分被遮住或無法辨認（「xxx」的部分）。序號刻在上節管上，通常下節管、調音管和喇叭口也有。請輸入刻印上的全部數字。",
        "result.unparsed": "<em>無法辨識為單一序號。請只輸入單簧管上刻的數字。</em>",
        "result.noMatch": "<strong>查無資料：</strong>這個號碼不在{0}有記錄的序號範圍內。請再核對一次單簧管上的數字。如果仍然不符，請將照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>，我們會看看。",
        "year.plain": "{0}年",
        "year.range": "{0}〜{1}年",
        "year.orLater": "{0}年以後",
        "year.approx": "約{0}",
        "chart.title": "您的單簧管在{0}序號表中的位置",
        "chart.th.serial": "序號",
        "chart.th.year": "製造年份",
        "chart.th.model": "型號時期",
        "chart.lettered": "含字母的序號",
        "chart.andUp": "{0}以上",
        "save.sheet": "在開啟的選單中選擇<strong>加入書籤</strong>或<strong>加入主畫面</strong>。",
        "save.tap": "點一下瀏覽器的分享圖示，然後選擇<strong>加入書籤</strong>。",
        "save.press": "按 <strong>{0}</strong> 即可將本頁加入書籤。",
        "save.copied": "已複製連結。",
        "save.copyThis": "請複製這個連結：<strong>{0}</strong>",
        "sold.loading": "正在搜尋在售商品和已售出檔案…",
        "sold.badge": "已售出",
        "brands.buffet-pro.name": "專業系列（R13 一系）",
        "brands.buffet-e13.name": "E13（法國製中階型號）",
        "brands.buffet-harmony.name": "和聲單簧管（E♭、中音、低音、倍低音）",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12（初學與學生型號）",
        "brands.buffet-pro.sections.0.label": "1928年以後只有數字的序號（R13 以前的型號、R13、RC、Festival、Prestige、Vintage、Tosca、Divine 共用一組序號）",
        "brands.buffet-e13.sections.0.label": "E13（獨立序號）",
        "brands.buffet-harmony.sections.0.label": "和聲單簧管（獨立序號）",
        "brands.buffet-pro.letteredLabel": "1885〜1927年含字母的序號（字母與數字的組合，例如 1K630 或 498A）",
        "brands.buffet-pro.letteredModel": "R13 以前（含字母序號的時期）",
        "brands.buffet-pro.letteredNote": "含字母的刻印中，字母在數字之前或之後。從1908年起，字母前面再多一位數字。請照刻印輸入。",
        "brands.buffet-pro.note": "本表來自 adams-music.shop，與 shopforband 和 Granlund 一致（已修正來源的兩處排版錯誤）。Buffet 1946〜57年與1964〜66年的記錄已經遺失，這些期間以每年約3,000支推估。1961年的結尾是68,717還是69,717，各來源不同。1962年在兩種說法中都從69,718開始，本表把有爭議的1,000個號碼算作1961年。公開的表到439,774（1997年）為止。更大的號碼屬於1998年以後。",
        "brands.buffet-pro.caveats.0.html": "<strong>記錄遺失：</strong>Buffet 1946〜1957年的帳冊沒有保存下來。顯示的期間是依前後年份以每年約3,000支推估的，不是工廠記錄的日期。",
        "brands.buffet-pro.caveats.1.html": "<strong>記錄遺失：</strong>Buffet 1964〜1966年的帳冊沒有保存下來。顯示的期間是推估的，不是工廠記錄的日期。",
        "brands.buffet-pro.caveats.2.html": "<strong>有爭議的1,000個號碼：</strong>公開的表對1961年的結尾是68,717還是69,717看法不一。本表把這些號碼算作1961年。1962年在各來源都從69,718開始。",
        "brands.buffet-pro.caveats.3.html": "<strong>超出公開的表：</strong>所有公開的 Buffet 清單都在439,774（1997年）結束。更大的號碼屬於1998年以後。刻印和琴盒的樣式可以縮小時期。歡迎寄照片給我們：<a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "brands.buffet-e13.note": "E13 的號碼來自 adams-music.shop，只有這一個來源。表中列的是每年的第一個序號。E13 的序號與專業系列的序號數字範圍重疊，所以請先選擇系列。",
        "brands.buffet-harmony.note": "和聲單簧管（E♭、中音、低音、倍低音）的號碼來自 adams-music.shop，只有這一個來源。序號從1950年的19,506開始，每年推進數十到數百號。",
        "brands.buffet-student.noChart": "<strong>這些型號沒有公開的表。</strong>E11、E12、B10、B12，以及有德國刻印的 Evette 單簧管，都由德國的 Schreiber 以 Schreiber 自己的編號製造，沒有逐年的公開清單。如果想知道製造時期，請將上節管和下節管刻印的照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "models.buffet-pro.0": "R13 以前",
        "models.buffet-pro.1": "最早期的 R13（已知最小的號碼是45,451；R13 這個名稱在1955年採用）",
        "models.buffet-pro.2": "R13 一系（多圓柱內膛）。RC、Festival、Prestige、Vintage、Tosca、Divine 也用同一組序號",
        "facts.buffet-pro.0": "序號前有 F 的樂器，是為歐洲樂團以 A=442〜444 製造的",
        "facts.buffet-pro.1": "已知最小的 R13 序號是45,451（1953年）。R13 這個名稱在1955年採用",
        "facts.buffet-pro.2": "約61,000起採用多圓柱內膛，成為今天所知的 R13",
        "facts.buffet-pro.3": "公開的逐年表在439,774（1997年）結束。之後的序號在找到來源之前，只標示時期而不標示年份"
      }
    },
    "zh-cn": {
      "copy": {
        "placeholder": "例如：157738、1K630",
        "soldEmpty": "目前在售商品和已售出档案中，都没有类似的单簧管。欢迎来信 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>，我们会看看您的单簧管。"
      },
      "s": {
        "sn.label": "输入序列号",
        "nudge.brand": "<strong>只差一步：</strong>在上方选择单簧管的系列，就能查出序列号 <strong>{0}</strong> 的制造年份。",
        "prompt.empty": "<em>请输入单簧管上刻的序列号。</em>",
        "result.yearLabel": "制造年份",
        "result.model": "<strong>推测型号：</strong>{0}",
        "result.letteredNoMatch": "<strong>查未找到：</strong>这个含字母的刻印不在公开的1885至1927年表中（这份表有一些小缺口）。请核对单簧管上的字母和数字。如果仍然不符，请将刻印的照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "result.masked": "<strong>只差一步：</strong>序列号似乎有一部分被遮住或无法辨认（「xxx」的部分）。序列号刻在上节管上，通常下节管、调音管和喇叭口也有。请输入刻印上的全部数字。",
        "result.unparsed": "<em>无法辨识为单一序列号。请只输入单簧管上刻的数字。</em>",
        "result.noMatch": "<strong>查未找到：</strong>这个号码不在{0}有记录的序列号范围内。请再核对一次单簧管上的数字。如果仍然不符，请将照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>，我们会看看。",
        "year.plain": "{0}年",
        "year.range": "{0}至{1}年",
        "year.orLater": "{0}年以后",
        "year.approx": "约{0}",
        "chart.title": "您的单簧管在{0}序列号表中的位置",
        "chart.th.serial": "序列号",
        "chart.th.year": "制造年份",
        "chart.th.model": "型号时期",
        "chart.lettered": "含字母的序列号",
        "chart.andUp": "{0}以上",
        "save.sheet": "在打开的菜单中选择<strong>加入书签</strong>或<strong>加入主画面</strong>。",
        "save.tap": "点击浏览器的分享图标，然后选择<strong>加入书签</strong>。",
        "save.press": "按 <strong>{0}</strong> 即可将本页加入书签。",
        "save.copied": "已复制链接。",
        "save.copyThis": "请复制这个链接：<strong>{0}</strong>",
        "sold.loading": "正在搜索在售商品和已售出档案…",
        "sold.badge": "已售出",
        "brands.buffet-pro.name": "专业系列（R13 一系）",
        "brands.buffet-e13.name": "E13（法国制中阶型号）",
        "brands.buffet-harmony.name": "和声单簧管（E♭、中音、低音、倍低音）",
        "brands.buffet-student.name": "E11 / E12 / B10 / B12（初学与学生型号）",
        "brands.buffet-pro.sections.0.label": "1928年以后只有数字的序列号（R13 以前的型号、R13、RC、Festival、Prestige、Vintage、Tosca、Divine 共用一组序列号）",
        "brands.buffet-e13.sections.0.label": "E13（独立序列号）",
        "brands.buffet-harmony.sections.0.label": "和声单簧管（独立序列号）",
        "brands.buffet-pro.letteredLabel": "1885至1927年含字母的序列号（字母与数字的组合，例如 1K630 或 498A）",
        "brands.buffet-pro.letteredModel": "R13 以前（含字母序列号的时期）",
        "brands.buffet-pro.letteredNote": "含字母的刻印中，字母在数字之前或之后。从1908年起，字母前面再多一位数字。请照刻印输入。",
        "brands.buffet-pro.note": "本表来自 adams-music.shop，与 shopforband 和 Granlund 一致（已修正来源的两处排版错误）。Buffet 1946至57年与1964至66年的记录已经遗失，这些期间以每年约3,000支推估。1961年的结尾是68,717还是69,717，各来源不同。1962年在两种说法中都从69,718开始，本表把有争议的1,000个号码算作1961年。公开的表到439,774（1997年）为止。更大的号码属于1998年以后。",
        "brands.buffet-pro.caveats.0.html": "<strong>记录遗失：</strong>Buffet 1946至1957年的帐册没有保存下来。显示的期间是依前后年份以每年约3,000支推估的，不是工厂记录的日期。",
        "brands.buffet-pro.caveats.1.html": "<strong>记录遗失：</strong>Buffet 1964至1966年的帐册没有保存下来。显示的期间是推估的，不是工厂记录的日期。",
        "brands.buffet-pro.caveats.2.html": "<strong>有争议的1,000个号码：</strong>公开的表对1961年的结尾是68,717还是69,717看法不一。本表把这些号码算作1961年。1962年在各来源都从69,718开始。",
        "brands.buffet-pro.caveats.3.html": "<strong>超出公开的表：</strong>所有公开的 Buffet 清单都在439,774（1997年）结束。更大的号码属于1998年以后。刻印和琴盒的样式可以缩小时期。欢迎寄照片给我们：<a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "brands.buffet-e13.note": "E13 的号码来自 adams-music.shop，只有这一个来源。表中列的是每年的第一个序列号。E13 的序列号与专业系列的序列号数字范围重叠，所以请先选择系列。",
        "brands.buffet-harmony.note": "和声单簧管（E♭、中音、低音、倍低音）的号码来自 adams-music.shop，只有这一个来源。序列号从1950年的19,506开始，每年推进数十到数百号。",
        "brands.buffet-student.noChart": "<strong>这些型号没有公开的表。</strong>E11、E12、B10、B12，以及有德国刻印的 Evette 单簧管，都由德国的 Schreiber 以 Schreiber 自己的编号制造，没有逐年的公开清单。如果想知道制造时期，请将上节管和下节管刻印的照片寄到 <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>。",
        "models.buffet-pro.0": "R13 以前",
        "models.buffet-pro.1": "最早期的 R13（已知最小的号码是45,451；R13 这个名称在1955年采用）",
        "models.buffet-pro.2": "R13 一系（多圆柱内膛）。RC、Festival、Prestige、Vintage、Tosca、Divine 也用同一组序列号",
        "facts.buffet-pro.0": "序列号前有 F 的乐器，是为欧洲乐团以 A=442至444 制造的",
        "facts.buffet-pro.1": "已知最小的 R13 序列号是45,451（1953年）。R13 这个名称在1955年采用",
        "facts.buffet-pro.2": "约61,000起采用多圆柱内膛，成为今天所知的 R13",
        "facts.buffet-pro.3": "公开的逐年表在439,774（1997年）结束。之后的序列号在找到来源之前，只标示时期而不标示年份"
      }
    }
    // DCSAX_ZH_END
  };
  var DCSAX_L = DCSAX_I18N[DCSAX_LANG_FULL] || DCSAX_I18N[DCSAX_LANG] || null;
  // True for every language with a dictionary (ja, ko).
  var DCSAX_LOC = !!DCSAX_L;
  if (DCSAX_L && DCSAX_L.copy) { for (var dcsaxK in DCSAX_L.copy) COPY[dcsaxK] = DCSAX_L.copy[dcsaxK]; }
  function dcsaxT(key, en) { return (DCSAX_L && DCSAX_L.s && typeof DCSAX_L.s[key] === "string") ? DCSAX_L.s[key] : en; }
  function dcsaxF(key, args) { return String(dcsaxT(key, "")).replace(/\{(\d+)\}/g, function (m, i) { return args[+i] === undefined ? "" : String(args[+i]); }); }
  // Localized year display from the dictionary (year.plain, year.range,
  // year.approx, year.orLater). Japanese: "1961" -> 1961年, "1964–66" ->
  // 1964〜66年, "c. 1946–57" -> 1946〜57年頃, "1998 or later" -> 1998年以降.
  function dcsaxYear(y) {
    var s = String(y), m = s.match(/^(\d{4}) or later$/);
    if (m) return dcsaxF("year.orLater", [m[1]]);
    var approx = /^c\. /.test(s);
    s = s.replace(/^c\. /, "");
    if ((m = s.match(/^(\d{4})[\u2013-](\d{2,4})$/))) s = dcsaxF("year.range", [m[1], m[2]]);
    else if (/^\d{4}$/.test(s)) s = dcsaxF("year.plain", [s]);
    return approx ? dcsaxF("year.approx", [s]) : s;
  }
  function dcsaxModel(brand, name) {
    var r = DATA.models[brand] || [];
    for (var i = 0; i < r.length; i++) if (r[i][2] === name) return dcsaxT("models." + brand + "." + i, name);
    if (DATA.brands[brand] && DATA.brands[brand].letteredModel === name) return dcsaxT("brands." + brand + ".letteredModel", name);
    return name;
  }
  function dcsaxFact(f) {
    for (var k in DATA.facts) { var i = DATA.facts[k].indexOf(f); if (i !== -1) return dcsaxT("facts." + k + "." + i, f[1]); }
    return f[1];
  }

  var els = {};
  ["brand-pills", "sn-input-wrapper", "sax-sn", "sax-sn-label", "lookup-result-box", "result-text-main",
   "patent-warning-box", "overlap-info-box", "caveat-box",
   "yamaha-model-wrapper", "yamaha-size-pills", "yamaha-model-pills",
   "era-wrapper", "era-label", "era-pills", "era-note",
   "lookup-actions", "show-sold-btn", "sold-similar", "sold-grid", "sold-note",
   "chart-section", "chart-title", "chart-wrap", "chart-note", "sell-box", "bookmark-hint", "save-row", "bookmark-btn", "copy-link-btn"].forEach(function (id) {
    els[id] = document.getElementById(id);
  });
  if (!els["brand-pills"]) return;
  // Localized: the static label and placeholder are English until a line is picked.
  if (DCSAX_LOC) { els["sax-sn-label"].textContent = dcsaxT("sn.label", ""); els["sax-sn"].placeholder = COPY.placeholder; }

  var state = { brand: "", era: "", sn: null, run: "", year: null, model: null, ysize: "", ystamp: "", soldLoaded: false, lastTracked: "" };

  // Usage metrics into the store's existing GA4 property (G-1ND1YB0GXQ).
  // Shopify's Google channel runs in a sandboxed pixel, so window.gtag
  // isn't available to page scripts — this page loads its own gtag into
  // the SAME property with page_view disabled, so nothing double-counts.
  // Events carry brand/year/model only — never the full serial.
  var GA4_ID = "G-1ND1YB0GXQ";
  try {
    if (!window.gtag) {
      var gs = document.createElement("script");
      gs.async = true;
      gs.src = "https://www.googletagmanager.com/gtag/js?id=" + GA4_ID;
      document.head.appendChild(gs);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GA4_ID, { send_page_view: false });
    }
  } catch (e) { /* metrics never break the tool */ }
  function track(name, params) {
    try { if (window.gtag) window.gtag("event", name, params || {}); } catch (e) { /* metrics never break the tool */ }
  }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function fmt(n) { return n.toLocaleString("en-US"); }

  // ── serial parsing (mirrors the DC Sax books app) ──────────────────────
  function parseSerial(text) {
    // Strip thousands separators inside a number ("68,551") but never the
    // spaces between two different numbers.
    var cleaned = text.toUpperCase().trim().replace(/(\d)[,.](\d)/g, "$1$2");
    if (cleaned.indexOf("X") !== -1) return { masked: true };
    var runs = (cleaned.match(/\d+/g) || []).filter(function (r) { return r.length >= 3; });
    if (runs.length !== 1) return null;
    return { sn: parseInt(runs[0], 10), run: runs[0], letters: cleaned.replace(/[^A-Z]/g, "") };
  }

  // Twin of buffetLetteredYear in the books app: "1K630" → key "1K_", n 630.
  function letteredParts(stamp) {
    var s = stamp.toUpperCase().replace(/[\s-]/g, "");
    var m = s.match(/^(\d)([A-Z])(\d+)$/);
    if (m) return { key: m[1] + m[2] + "_", n: parseInt(m[3], 10) };
    m = s.match(/^([A-Z])(\d+)$/);
    if (m) return { key: m[1] + "_", n: parseInt(m[2], 10) };
    m = s.match(/^(\d+)([A-Z])$/);
    if (m) return { key: "_" + m[2], n: parseInt(m[1], 10) };
    return null;
  }
  function letteredYear(raw, table) {
    var want = letteredParts(raw.trim());
    if (!want) return null;
    for (var i = 0; i < table.length; i++) {
      var blocks = table[i][1].split(",");
      for (var j = 0; j < blocks.length; j++) {
        var ends = blocks[j].trim().split("–");
        var lo = letteredParts(ends[0]), hi = letteredParts(ends[1] || "");
        if (!lo || !hi || lo.key !== want.key) continue;
        if (want.n >= lo.n && want.n <= hi.n) return table[i][0];
      }
    }
    return null;
  }

  function yearFromSteps(sn, steps, fallback) {
    for (var i = 0; i < steps.length; i++) if (sn <= steps[i][0]) return steps[i][1];
    return fallback;
  }

  function modelFor(brand, sn) {
    var ranges = DATA.models[brand] || [];
    if (!ranges.length && DATA.brands[brand] && DATA.brands[brand].eras) ranges = DATA.models[dataKey(brand, state.era)] || [];
    for (var i = 0; i < ranges.length; i++) {
      if (sn >= ranges[i][0] && sn <= ranges[i][1]) return ranges[i][2];
    }
    return null;
  }

  function lookupYear(brand, parsed) {
    var sn = parsed.sn, run = parsed.run;
    if (brand === "yanagisawa" && run.length >= 7) {
      var starts = [2, 1];
      for (var s = 0; s < starts.length; s++) {
        var code = parseInt(run.substring(starts[s], starts[s] + 2), 10);
        if (code >= 60 && code <= 79) {
          return { year: "19" + run.substring(starts[s], starts[s] + 2), model: "Early Professional Series (A6 / T6 / S6 Era)" };
        }
      }
    }
    if (brand === "conn" && parsed.letters !== "" && parsed.letters !== "M") {
      return { unknownLetters: true };
    }
    var brandDef = DATA.brands[brand];
    for (var i = 0; i < brandDef.sections.length; i++) {
      var sec = brandDef.sections[i];
      if (brandDef.eras && sec.era !== state.era) continue;
      if (sn < sec.min) continue;
      if (sec.hardMax && sn > sec.hardMax) continue;
      var last = sec.steps.length ? sec.steps[sec.steps.length - 1][0] : 0;
      if (sn > last && !sec.fallback) continue;
      return { year: yearFromSteps(sn, sec.steps, sec.fallback), section: sec, model: modelFor(brand, sn) };
    }
    return null;
  }

  // ── brand pills ────────────────────────────────────────────────────────
  BRAND_ORDER.forEach(function (key) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "brand-pill";
    btn.textContent = DCSAX_LOC ? dcsaxT("brands." + key + ".name", "") : DATA.brands[key].name;
    btn.setAttribute("data-brand", key);
    btn.addEventListener("click", function () {
      // Switching from one brand to another clears the serial (owner,
      // 2026-08-08) — a Selmer number has no business dating a Conn. The
      // first brand pick after typing keeps it: that's the nudge flow.
      if (state.brand && state.brand !== key) {
        els["sax-sn"].value = "";
        state.lastTracked = "";
        state.ysize = "";
        state.ystamp = "";
        state.era = "";
      }
      selectBrand(key);
      runLookup();
    });
    els["brand-pills"].appendChild(btn);
  });

  function selectBrand(key) {
    state.brand = key;
    var pills = els["brand-pills"].children;
    for (var i = 0; i < pills.length; i++) {
      pills[i].className = "brand-pill" + (pills[i].getAttribute("data-brand") === key ? " selected" : "");
    }
    // Yamaha is model-first: the model picker appears and the serial box
    // stays CLOSED until a model is chosen (owner, 2026-08-08) — the
    // serial refines a model, it never leads.
    var yamaha = key === "yamaha";
    if (els["yamaha-model-wrapper"]) els["yamaha-model-wrapper"].style.display = yamaha ? "block" : "none";
    els["sax-sn-label"].textContent = DCSAX_LOC && !yamaha ? dcsaxT("sn.label", "") : yamaha ? "Serial Number (optional — narrows the years)" : "Enter Serial Number";
    els["sax-sn"].placeholder = yamaha ? "e.g. C04879 or 188868" : COPY.placeholder;
    // A brand whose sequences overlap (Buffet saxophones restarted at 1
    // after the war) asks which era FIRST, the way Yamaha asks the model:
    // the serial box stays closed until the era is picked, because the
    // same number is two different horns.
    var brandDef = DATA.brands[key];
    var eras = brandDef.eras || null;
    if (eras && state.era && !eras.some(function (e) { return e.key === state.era; })) state.era = "";
    els["era-wrapper"].style.display = eras ? "block" : "none";
    if (eras) {
      els["era-label"].textContent = brandDef.eraLabel || "Which era?";
      els["era-note"].innerHTML = esc(brandDef.eraNote || "") + (brandDef.aside ? "<br><br>" + brandDef.aside : "");
      renderEraPills(eras);
      if (!state.era) pulseEraPills();
    }
    // A pill with no chart at all (student clarinets on Schreiber numbers)
    // explains itself instead of asking for a number it can't use.
    var noChart = !!brandDef.noChart;
    els["sn-input-wrapper"].style.display = (yamaha && !state.ystamp) || (eras && !state.era) || noChart ? "none" : "block";
    if (yamaha) {
      renderYamahaPills();
      // First arrival with nothing chosen: draw the eye to the picker.
      if (!state.ysize && !state.ystamp) pulseYamahaPills();
    }
  }

  function renderEraPills(eras) {
    var ep = els["era-pills"];
    ep.innerHTML = "";
    eras.forEach(function (e) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "brand-pill" + (state.era === e.key ? " selected" : "");
      btn.textContent = e.label;
      btn.addEventListener("click", function () {
        state.era = e.key;
        els["sn-input-wrapper"].style.display = "block";
        renderEraPills(eras);
        runLookup();
      });
      ep.appendChild(btn);
    });
  }

  var ePulseTimer = null;
  function pulseEraPills() {
    var el = els["era-pills"];
    el.className = "brand-pills";
    void el.offsetWidth; /* restart the animation */
    el.className = "brand-pills pulse";
    if (ePulseTimer) clearTimeout(ePulseTimer);
    ePulseTimer = setTimeout(function () { el.className = "brand-pills"; }, 2000);
  }

  // Models, facts and search plans for an era-split brand live under
  // "brand:era" so a pre-war number never borrows a post-war model name.
  function dataKey(brand, era) {
    return era ? brand + ":" + era : brand;
  }

  var yPulseTimer = null;
  function pulseYamahaPills() {
    var el = els["yamaha-size-pills"];
    el.className = "brand-pills";
    void el.offsetWidth; /* restart the animation */
    el.className = "brand-pills pulse";
    if (yPulseTimer) clearTimeout(yPulseTimer);
    yPulseTimer = setTimeout(function () { el.className = "brand-pills"; }, 2000);
  }

  var pulseTimer = null;
  function pulsePills() {
    els["brand-pills"].className = "brand-pills";
    void els["brand-pills"].offsetWidth; /* restart the animation */
    els["brand-pills"].className = "brand-pills pulse";
    if (pulseTimer) clearTimeout(pulseTimer);
    pulseTimer = setTimeout(function () { els["brand-pills"].className = "brand-pills"; }, 2000);
  }

  els["sax-sn"].addEventListener("input", runLookup);

  // ── keep the year on screen ────────────────────────────────────────────
  // On a laptop the serial input sits near the bottom of the screen and the
  // year renders below it, out of view; on a phone it is under the keyboard
  // (owner request 2026-10-16). The first time a brand produces a year, the
  // page scrolls so the input sits just under the sticky header. Later
  // keystrokes for the same brand leave the page alone, and so does a year
  // that is already fully on screen. The header height is measured, not
  // assumed: Prestige uses 158px on a desktop and 54px on a phone.
  var revealedBrand = null;
  function stickyHeaderHeight() {
    var h = 0;
    try {
      var nodes = document.querySelectorAll(".shopify-section-group-header-group, header");
      for (var i = 0; i < nodes.length; i++) {
        var cs = getComputedStyle(nodes[i]);
        if (cs.position !== "sticky" && cs.position !== "fixed") continue;
        var r = nodes[i].getBoundingClientRect();
        var bottom = cs.position === "fixed" ? r.bottom : (parseFloat(cs.top) || 0) + r.height;
        if (bottom > h) h = bottom;
      }
    } catch (e) { /* no header found: scroll to the top of the input */ }
    return h;
  }
  function revealResult() {
    var brand = state.brand;
    if (!brand || revealedBrand === brand) return;
    revealedBrand = brand;
    // A timeout, not requestAnimationFrame: a tab in the background gets no
    // animation frames, so the scroll would wait until the tab is shown.
    setTimeout(function () {
      var main = els["result-text-main"];
      var year = main.querySelector(".result-year");
      if (!year) return;
      var models = main.querySelectorAll(".result-model");
      var last = models.length ? models[models.length - 1] : year;
      var headerH = stickyHeaderHeight();
      var viewH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      if (year.getBoundingClientRect().top >= headerH && last.getBoundingClientRect().bottom <= viewH) return;
      // The label above the input comes along, so the field keeps its name.
      var anchor = els["sax-sn-label"] || els["sax-sn"];
      var target = Math.max(0, window.pageYOffset + anchor.getBoundingClientRect().top - headerH - 12);
      if ("scrollBehavior" in document.documentElement.style) window.scrollTo({ top: target, behavior: "smooth" });
      else window.scrollTo(0, target);
    }, 0);
  }

  function hideAll() {
    ["patent-warning-box", "overlap-info-box", "caveat-box",
     "lookup-actions", "sold-similar", "chart-section", "sell-box"].forEach(function (id) {
      if (els[id]) els[id].style.display = "none"; /* the clarinet page has no sell box */
    });
    els["caveat-box"].innerHTML = ""; /* caveats and notes append per lookup */
    els["overlap-info-box"].className = "overlap-tip"; /* Yamaha borrows it as the purple tip */
  }

  function caveat(html) {
    els["caveat-box"].innerHTML += '<div class="caveat-tip">' + html + "</div>";
    els["caveat-box"].style.display = "block";
  }

  function subtleNote(text) {
    els["caveat-box"].innerHTML += '<p class="subtle-note">' + text + "</p>";
    els["caveat-box"].style.display = "block";
  }

  var ADOLPHE_CTA = '<div class="adolphe-cta">Do you have one you are interested in selling? We would love to hear from you. Please email <a href="mailto:paul@dcsax.com" style="color:#c5a059; font-weight:bold;">paul@dcsax.com</a></div>';

  // ── the lookup ─────────────────────────────────────────────────────────
  function runLookup() {
    var brand = state.brand;
    hideAll();
    state.soldLoaded = false;
    els["sold-grid"].innerHTML = "";
    if (!brand) {
      // The serial box is visible from the start (owner request 2026-08-08),
      // so a serial with no brand gets a pointed nudge, not silence.
      var typed = els["sax-sn"].value.trim();
      if (typed) {
        els["lookup-result-box"].style.display = "block";
        els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxF("nudge.brand", [esc(typed)]) : "<strong>Almost there:</strong> select your horn&rsquo;s manufacturer above to date serial <strong>" + esc(typed) + "</strong>.";
        pulsePills();
      } else {
        els["lookup-result-box"].style.display = "none";
      }
      return;
    }
    els["lookup-result-box"].style.display = "block";

    if (brand === "yamaha") {
      runYamahaLookup();
      return;
    }

    var brandDefNow = DATA.brands[brand];
    if (brandDefNow.noChart) {
      els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxT("brands." + brand + ".noChart", "") : brandDefNow.noChart;
      showActions(null);
      els["show-sold-btn"].style.display = "none"; /* nothing is "similar" to an undatable model */
      revealExtras();
      setPermalink(brand, "");
      return;
    }
    if (brandDefNow.eras && !state.era) {
      els["result-text-main"].innerHTML = "<strong>Almost there:</strong> " + esc(brandDefNow.eraPrompt || "pick the era above first.");
      return;
    }

    var raw = els["sax-sn"].value.trim();
    if (!raw) { els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxT("prompt.empty", "") : "<em>Enter the serial number stamped on your " + COPY.noun + ".</em>"; return; }

    // Lettered stamps (Buffet clarinets, 1885–1927: "1K630") are matched
    // against their own table before the digit parser can misread them.
    // Only a stamp SHAPED like the lettered era ("1K630", "498A") takes this
    // branch; a masked "218xxx" falls through to the masked-serial nudge.
    if (brandDefNow.lettered && letteredParts(raw)) {
      var lyear = letteredYear(raw, brandDefNow.lettered);
      if (lyear) {
        state.sn = null; state.run = ""; state.year = lyear; state.model = brandDefNow.letteredModel || null;
        var lout = DCSAX_LOC ? '<div class="result-year-label">' + dcsaxT("result.yearLabel", "") + "</div>" : '<div class="result-year-label">Year of Manufacture</div>';
        lout += DCSAX_LOC ? '<div class="result-year">' + esc(dcsaxYear(lyear)) + "</div>" : '<div class="result-year">' + esc(lyear) + "</div>";
        if (state.model) lout += DCSAX_LOC ? '<div class="result-model">' + dcsaxF("result.model", [esc(dcsaxModel(brand, state.model))]) + "</div>" : '<div class="result-model"><strong>Estimated Model:</strong> ' + esc(state.model) + "</div>";
        els["result-text-main"].innerHTML = lout;
        revealResult();
        if (brandDefNow.letteredNote) subtleNote(DCSAX_LOC ? dcsaxT("brands." + brand + ".letteredNote", "") : brandDefNow.letteredNote);
        showActions({ year: lyear });
        if (COPY.sellBox) els["sell-box"].style.display = "block";
        revealExtras();
        renderChart(brand, null, lyear);
        setPermalink(brand, raw);
        prefillValuationForm(brand, { year: lyear, model: state.model }, raw);
        var lkey = brand + ":" + raw.toUpperCase();
        if (state.lastTracked !== lkey) { state.lastTracked = lkey; track("serial_lookup", { brand: brand, year: lyear, model: state.model || "(lettered)" }); }
        return;
      }
      els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxT("result.letteredNoMatch", "") : "<strong>No match:</strong> that lettered stamp isn&rsquo;t in the published 1885–1927 table, which has small gaps. Check the letter and the digits on the " + COPY.noun + ", and if it still doesn&rsquo;t match, email a photo of the stamp to <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>.";
      renderChart(brand, null);
      return;
    }

    var parsed = parseSerial(raw);
    if (parsed && parsed.masked) {
      els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxT("result.masked", "") : "<strong>Almost there:</strong> part of that serial number looks masked or unreadable (the “xxx”). Find the full number stamped on the " + COPY.noun + " — " + COPY.serialWhere + " — and enter every digit.";
      return;
    }
    if (!parsed) {
      els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxT("result.unparsed", "") : "<em>That doesn&rsquo;t read as a single serial number — enter just the digits stamped on the " + COPY.noun + ".</em>";
      return;
    }

    if (DATA.patents.indexOf(parsed.sn) !== -1) {
      els["patent-warning-box"].style.display = "block";
      els["patent-warning-box"].innerHTML = "💡 <strong>It looks like you found a structural design patent stamp instead of the serial number.</strong><br>You are in the exact right area of the saxophone, but this number is a design marking shared by thousands of vintage horns from this generation.<br><br><strong>How to find your unique serial number:</strong> Look closely right above or below that patent text on the back of the horn (near the thumb hook). The true serial number will be a completely separate number stamped cleanly into the brass, often grouped alongside a class code like &lsquo;6M&rsquo; or an &lsquo;M&rsquo; letter prefix.";
      els["result-text-main"].innerHTML = "<strong>Notice:</strong> Patent stamp detected — see below.";
      return;
    }

    var hit = lookupYear(brand, parsed);
    state.sn = parsed.sn;
    state.run = parsed.run;

    if (hit && hit.unknownLetters) {
      els["result-text-main"].innerHTML = "<strong>Letter-prefix Conn serial:</strong> Conn&rsquo;s later letter-prefix serial systems (1960s on) have no reliable public chart, so an honest year isn&rsquo;t possible from the serial alone.";
      showActions(null);
      return;
    }
    if (!hit) {
      els["result-text-main"].innerHTML = DCSAX_LOC ? dcsaxF("result.noMatch", [esc(dcsaxT("brands." + brand + ".name", ""))]) : "<strong>No match:</strong> that number falls outside the documented " + esc(DATA.brands[brand].name) + " serial ranges. Double-check the digits on the " + COPY.noun + " — and if it still doesn&rsquo;t match, email a photo to <a href='mailto:paul@dcsax.com'>paul@dcsax.com</a>; we&rsquo;d love to take a look.";
      if (DATA.brands[brand].aside) subtleNote(DATA.brands[brand].aside);
      renderChart(brand, null);
      return;
    }

    state.year = hit.year;
    state.model = hit.model || null;

    // The year is the answer people came for — it gets the big type
    // (owner request 2026-08-08); the model reads as the supporting line.
    var out = DCSAX_LOC ? '<div class="result-year-label">' + dcsaxT("result.yearLabel", "") + "</div>" : '<div class="result-year-label">Year of Manufacture</div>';
    out += DCSAX_LOC ? '<div class="result-year">' + esc(dcsaxYear(hit.year)) + "</div>" : '<div class="result-year">' + esc(hit.year) + "</div>";
    if (hit.model) out += DCSAX_LOC ? '<div class="result-model">' + dcsaxF("result.model", [esc(dcsaxModel(brand, hit.model))]) + "</div>" : '<div class="result-model"><strong>Estimated Model:</strong> ' + esc(hit.model) + "</div>";
    if (brand === "adolphe sax") {
      out += '<div class="result-model"><strong>Factory:</strong> ' + adolpheFactory(parsed.sn) + ", France</div>";
      out += parsed.sn <= 3600
        ? "<em style='font-size:14px;color:#666;'>Built by Selmer under the historic Adolphe Sax brand name (1931–1944).</em>"
        : "<em style='font-size:14px;color:#666;'>Original Adolphe Sax workshop instrument — made by the inventor of the saxophone himself.</em>";
      out += ADOLPHE_CTA;
    }
    els["result-text-main"].innerHTML = out;
    revealResult();

    brandCaveats(brand, parsed.sn, hit.year);
    if (DATA.brands[brand].aside) subtleNote(DATA.brands[brand].aside);
    (DATA.voiceNotes[brand] || []).forEach(function (n) {
      if (parsed.sn >= n[0] && parsed.sn <= n[1]) subtleNote(n[2]);
    });
    showActions(hit);
    if (COPY.sellBox) els["sell-box"].style.display = "block";
    revealExtras();
    renderChart(brand, parsed.sn);
    setPermalink(brand, raw);
    prefillValuationForm(brand, hit, raw);

    // One event per distinct successful lookup, not one per keystroke.
    var key = brand + ":" + parsed.sn;
    if (state.lastTracked !== key) {
      state.lastTracked = key;
      track("serial_lookup", { brand: brand, year: hit.year, model: hit.model || "(none)" });
    }
  }

  // ── Yamaha: model-first (no serial chart exists — sequences run per
  //    model, restarted twice, letter prefixes from Oct 2006; mirrors
  //    yamahaYearEstimate in the books app) ───────────────────────────────
  function ySpecs(size) {
    return DATA.yamaha.models.filter(function (m) { return m.size === size; });
  }
  function ySpecByStamp(stamp) {
    for (var i = 0; i < DATA.yamaha.models.length; i++) {
      if (DATA.yamaha.models[i].stamp === stamp) return DATA.yamaha.models[i];
    }
    return null;
  }

  function renderYamahaPills() {
    var sp = els["yamaha-size-pills"];
    sp.innerHTML = "";
    DATA.yamaha.sizes.forEach(function (size) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "brand-pill" + (state.ysize === size ? " selected" : "");
      btn.textContent = size.charAt(0).toUpperCase() + size.slice(1);
      btn.addEventListener("click", function () {
        state.ysize = size;
        var kept = state.ystamp ? ySpecByStamp(state.ystamp) : null;
        if (!kept || kept.size !== size) state.ystamp = "";
        renderYamahaPills();
        runLookup();
      });
      sp.appendChild(btn);
    });
    var mp = els["yamaha-model-pills"];
    mp.innerHTML = "";
    if (!state.ysize) return;
    ySpecs(state.ysize).forEach(function (m) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "brand-pill" + (state.ystamp === m.stamp ? " selected" : "");
      btn.textContent = m.stamp;
      btn.addEventListener("click", function () {
        state.ystamp = m.stamp;
        els["sn-input-wrapper"].style.display = "block"; /* the serial box opens up */
        renderYamahaPills();
        runLookup();
      });
      mp.appendChild(btn);
    });
  }

  // ── Serial → generation verdicts (mirrors yamahaVerdict in the books
  //    app; evidence cited there). The stamp never says II/III, so for
  //    the 62, 82Z, and YBS-62 families the generation is an OUTCOME of
  //    the serial — or an honest "check these two things" when the
  //    serial genuinely can't say (owner directive, 2026-08-08). ───────
  function ySerialParts(raw) {
    // A/B/Q prefixes are noise, not scheme (letters began at C; owner
    // ruling 2026-08-08) — read the digits as a plain serial.
    var s = raw.trim().toUpperCase().replace(/[,.\s]/g, "").replace(/^[ABQ]-?(?=[0-9X])/, "");
    var lettered = s.match(/^([A-Z])-?[0-9X]/);
    if (lettered) return { letter: lettered[1], sn: null };
    var masked = s.match(/^([0-9]+)(X*)/);
    if (!masked || masked[1] === "") return { letter: null, sn: null };
    return { letter: null, sn: parseInt(masked[1], 10) * Math.pow(10, masked[2].length) };
  }

  var Y_FENCES = {
    "62-plain-mid": "<strong>Which generation?</strong> A plain serial in this range is usually an original 62 (c. 1983–2002), but the very first 62IIs (late 2002) reused these numbers. Two checks settle it: one continuous keyguard running across the low-note keys = original 62; separate guards (low C on its own, low B/B♭ sharing one) = 62II. A neck shield stamped “G1” also means 62II.",
    "62-d-prefix": "<strong>Which generation?</strong> A “D” serial is either a late 62II (2010–2012) or an early 62III — Yamaha restarted the 62III’s serials at D00001 in 2013. Check the small shield on the neck: stamped “G1” = 62II, stamped “62” = 62III. The 62III also carries noticeably more ornate bell engraving.",
    "82z-d-prefix": "<strong>Which generation?</strong> Almost certainly a first-version 82Z (c. 2010–2013) — but the earliest 82ZIIs can’t be fully ruled out. A neck shield stamped “V1”, metal pad resonators, or a seamless one-piece bell = 82ZII; a “G1” neck = 82Z (first version).",
    "82z-e-tenor": "<strong>Which generation?</strong> An “E” serial tenor Z is most likely an 82ZII (2014 on), though the last first-version 82Z tenors overlap. A “V1” neck and metal pad resonators = 82ZII; a “G1” neck = 82Z (first version).",
    "ybs-62": "<strong>Original or 62II?</strong> Serial numbers can’t separate them — the II’s serials overlap the originals’. Check the bottom of the body: a peg-receiver socket = YBS-62II (2020 on; sold in Japan from ~2015). The II also has a visibly shorter bell and a tear-drop front-F touchpiece.",
    "yss62-tonehole": "<strong>Quick visual check:</strong> around serial ~10,000 (≈1988) the low C# tonehole moved from the front-center of the body tube to in line with B/B♭ — front-center = pre-1988, in line = 1988 on.",
    "62-tells": "<strong>Telling the generations apart by eye:</strong> one continuous keyguard running across the low-note keys = original 62; separate guards (low C on its own, low B/B♭ sharing one) = 62II or 62III. On the neck, a shield stamped “G1” = 62II and “62” = 62III (the 62III also carries noticeably more ornate bell engraving).",
    "82z-tells": "<strong>Telling them apart by eye:</strong> a neck shield stamped “V1”, metal pad resonators, or a seamless one-piece bell = 82ZII; a “G1” neck = 82Z (first version)."
  };

  function yVerdict(spec, raw) {
    var p = ySerialParts(raw);
    if (spec.family === "62") {
      if (p.letter === "C") return { lo: 2006, hi: 2010, generation: "62II", fence: null };
      if (p.letter === "D") return { lo: 2010, hi: null, generation: null, fence: "62-d-prefix" };
      if (p.letter !== null) return { lo: 2013, hi: null, generation: "62III", fence: null };
      if (p.sn !== null && p.sn >= 110001) return { lo: 2003, hi: 2006, generation: "62II", fence: null };
      if (p.sn !== null && p.sn > 10000) return { lo: 1983, hi: 2003, generation: null, fence: "62-plain-mid" };
      if (p.sn !== null) return { lo: 1979, hi: 1984, generation: "Original 62 (early years)", fence: null };
      return { lo: 1979, hi: null, generation: null, fence: null };
    }
    if (spec.family === "82Z") {
      var zStart = spec.size === "tenor" ? 2002 : 2003;
      if (p.letter === "C") return { lo: 2006, hi: 2010, generation: "82Z (first version)", fence: null };
      if (p.letter === "D") return { lo: 2010, hi: 2014, generation: null, fence: "82z-d-prefix" };
      if (p.letter !== null) {
        if (spec.size === "tenor" && p.letter === "E") return { lo: 2013, hi: null, generation: null, fence: "82z-e-tenor" };
        return { lo: 2013, hi: null, generation: "82ZII", fence: null };
      }
      if (p.sn !== null) return { lo: zStart, hi: 2006, generation: "82Z (first version)", fence: null };
      return { lo: zStart, hi: null, generation: null, fence: null };
    }
    if (spec.family === "YBS62") {
      if (p.letter === null && p.sn !== null && p.sn < 40000) return { lo: 1980, hi: 2004, generation: "Original YBS-62", fence: null };
      if (p.letter === null && p.sn !== null) return { lo: 2003, hi: null, generation: null, fence: "ybs-62" };
      return { lo: 1980, hi: null, generation: null, fence: "ybs-62" };
    }
    if (spec.family === "YSS62") {
      if (p.sn !== null && p.sn >= 10000) return { lo: 1988, hi: 1990, generation: null, fence: "yss62-tonehole" };
      if (p.sn !== null) return { lo: 1978, hi: 1988, generation: null, fence: "yss62-tonehole" };
      return { lo: 1978, hi: 1990, generation: null, fence: null };
    }
    return null;
  }

  // The serial's letter-prefix era, for models whose stamp already names
  // the era (875 vs 875EX…). A missing letter only means "pre-October
  // 2006" on altos and tenors — real sopranos and baritones never joined
  // the letter scheme, so absence proves nothing there.
  function yamahaEra(raw, size) {
    // A/B/Q prefixes are noise — read the digits (same rule as ySerialParts).
    var s = raw.trim().toUpperCase().replace(/^[ABQ][\s-]?(?=[0-9X])/, "");
    var m = s.match(/^([A-Z])[\s-]?[0-9X]/);
    if (m) {
      var eras = DATA.yamaha.prefixEras;
      for (var i = 0; i < eras.length; i++) {
        if (eras[i].prefix === m[1]) return { start: eras[i].start, end: eras[i].end, letter: m[1] };
      }
      return { start: 2013, end: null, letter: m[1] };
    }
    if (/^[0-9]/.test(s) && (size === "alto" || size === "tenor")) {
      return { start: null, end: 2006, letter: "" };
    }
    return null;
  }

  // Family stamps resolve through the generation verdicts; other models
  // intersect with the letter-prefix eras. "narrowed" is true only when
  // the serial actually CHANGED the window — a YAS-855 (1988–1992) gains
  // nothing from "no letter = pre-2006", and saying so reads as nonsense
  // (owner, 2026-08-08). A contradiction falls back to the model window.
  function yamahaWindow(spec, raw) {
    var lo = spec.start, hi = spec.end;
    var verdict = spec.family ? yVerdict(spec, raw || "") : null;
    var era = null, narrowed = false;
    if (verdict) {
      var vLo = Math.max(lo, verdict.lo);
      var vHi = hi === null ? verdict.hi : verdict.hi === null ? hi : Math.min(hi, verdict.hi);
      if (vHi === null || vLo <= vHi) { lo = vLo; hi = vHi; }
    } else {
      era = raw ? yamahaEra(raw, spec.size) : null;
      if (era) {
        var nLo = era.start === null ? lo : Math.max(lo, era.start);
        var nHi = hi === null ? era.end : era.end === null ? hi : Math.min(hi, era.end);
        if (nHi === null || nLo <= nHi) {
          narrowed = nLo !== lo || nHi !== hi;
          lo = nLo; hi = nHi;
        }
      }
    }
    var label = hi === null ? lo + "–present" : lo === hi ? "c. " + lo : "c. " + lo + "–" + hi;
    return {
      lo: lo, hi: hi, era: era, narrowed: narrowed, label: label,
      generation: verdict ? verdict.generation : null,
      fence: verdict ? verdict.fence : null
    };
  }

  function yamahaYearsText(m) {
    return (m.approx ? "c. " : "") + m.start + "–" + (m.end === null ? "present" : m.end);
  }

  function runYamahaLookup() {
    if (!state.ystamp) {
      els["result-text-main"].innerHTML = state.ysize
        ? "<strong>Almost there:</strong> pick your model above. The stamp is on the back of the body tube, directly above the serial number."
        : "<strong>Yamaha works differently.</strong> Yamaha has never published a serial chart — and none can exist: serial sequences run separately for every model and were restarted several times. Pick your horn’s size above and we’ll date it the honest way: by model generation, refined by the serial’s letter prefix.";
      revealExtras();
      setYamahaPermalink("");
      return;
    }

    var spec = ySpecByStamp(state.ystamp);
    var raw = els["sax-sn"].value.trim();
    var win = yamahaWindow(spec, raw);
    state.sn = null;
    state.run = "";
    state.year = win.label;
    state.model = spec.stamp;

    var out = '<div class="result-year-label">Production Window</div>';
    out += '<div class="result-year">' + esc(win.label) + "</div>";
    out += '<div class="result-model"><strong>Model:</strong> Yamaha ' + esc(spec.stamp) + "</div>";
    if (win.generation) out += '<div class="result-model"><strong>Generation:</strong> ' + esc(win.generation) + "</div>";
    // Family stamps show their generation years up front — before any
    // serial is typed (owner request 2026-08-08); the resolved row lights
    // up once the serial decides.
    var genRows = spec.family ? DATA.yamaha.generations[spec.family + "|" + spec.size] : null;
    if (genRows) {
      var gout = '<table style="font-size:14px;margin-top:10px;border-collapse:collapse;">';
      genRows.forEach(function (g) {
        // Exact name or name-plus-qualifier ("Original 62 (early years)")
        // — a bare prefix match would light 62III up as 62II too.
        var isIt = win.generation && (win.generation === g[0] || win.generation.indexOf(g[0] + " ") === 0);
        gout += "<tr" + (isIt ? ' style="font-weight:bold;color:#b28f47;"' : "") +
          '><td style="padding:2px 14px 2px 0;white-space:nowrap;">' + esc(g[0]) + "</td><td>" + esc(g[1]) + (isIt ? " ← this horn" : "") + "</td></tr>";
      });
      gout += "</table>";
      out += gout;
    } else if (spec.note && !win.generation && !win.fence) {
      out += '<div class="result-model" style="font-size:14px;color:#666;margin-top:4px;">' + esc(spec.note) + "</div>";
    }
    els["result-text-main"].innerHTML = out;
    revealResult();

    if (win.fence) caveat(Y_FENCES[win.fence]);
    if (spec.family && !raw) {
      subtleNote("Enter the serial number above — it usually pins down the generation.");
      // No serial yet? The visual cues still work from photos alone.
      if (spec.family === "62") caveat(Y_FENCES["62-tells"]);
      else if (spec.family === "82Z") caveat(Y_FENCES["82z-tells"]);
    }
    if (win.era && win.narrowed) {
      subtleNote(win.era.letter
        ? "The “" + esc(win.era.letter) + "” serial prefix narrows this horn within the model’s run — Yamaha moved to lettered serials in October 2006 and advanced the letter every few years."
        : "No letter in front of the serial means it was made before October 2006, when Yamaha restarted alto and tenor serial sequences at C00001.");
    }
    if (!spec.family && raw && !win.narrowed) {
      subtleNote("The serial itself doesn’t narrow this one — no usable Yamaha serial data exists for this model, so the window above is the model’s full production run.");
    }
    if (win.lo <= DATA.yamaha.purpleEnd && /6(1|2)$|62R$/.test(spec.stamp)) {
      els["overlap-info-box"].className = "purple-logo-tip";
      els["overlap-info-box"].style.display = "block";
      els["overlap-info-box"].innerHTML = "💡 <strong>Purple logo?</strong> Yamaha’s bell logo had a purple fill until about 1990–91, when it became a plain stamped logo — purple means earlier production, plain means later.";
    }
    caveat("<strong>Want the exact month and year?</strong> Yamaha’s Band &amp; Orchestral support will confirm it from the serial by email (records reach back to roughly 1982): <a href='mailto:bandandorchestra@yamaha.com'>bandandorchestra@yamaha.com</a>.");

    showActions(null);
    els["sell-box"].style.display = "block";
    revealExtras();
    renderYamahaChart(spec, win.generation);
    setYamahaPermalink(raw);
    prefillValuationForm("yamaha", { model: spec.stamp, year: win.label }, raw);

    var key = "yamaha:" + spec.stamp + ":" + raw;
    if (state.lastTracked !== key) {
      state.lastTracked = key;
      track("serial_lookup", { brand: "yamaha", year: win.label, model: spec.stamp });
    }
  }

  function renderYamahaChart(spec, gen) {
    var html = "<table><thead><tr><th>Model</th><th>Years</th><th>Notes</th></tr></thead><tbody>";
    var hitId = null;
    ySpecs(spec.size).forEach(function (m, i) {
      var isSel = m.stamp === spec.stamp;
      var rows = m.family ? DATA.yamaha.generations[m.family + "|" + m.size] : null;
      if (rows) {
        // One row per variation (owner, 2026-08-08) under a label row
        // carrying the shared-stamp fact. Highlight the resolved
        // generation, or the label row while the generation is open.
        var genHtml = "";
        var genHit = false;
        rows.forEach(function (g, j) {
          var isIt = isSel && gen && (gen === g[0] || gen.indexOf(g[0] + " ") === 0);
          var id = "ychart-r-" + i + "-" + j;
          if (isIt) { genHit = true; if (!hitId) hitId = id; }
          genHtml += '<tr id="' + id + '"' + (isIt ? ' class="chart-hit"' : "") +
            '><td class="chart-sn" style="padding-left:22px;">' + esc(g[0]) + '</td><td style="white-space:nowrap;">' + esc(g[1]) + "</td><td>" + esc(g[2] || "") + "</td></tr>";
        });
        var labelId = "ychart-r-" + i + "-label";
        var labelHit = isSel && !genHit;
        if (labelHit && !hitId) hitId = labelId;
        html += '<tr id="' + labelId + '" class="chart-section-label' + (labelHit ? " chart-hit" : "") +
          '"><td colspan="3">' + esc(m.stamp) + (m.note ? " — " + esc(m.note) : "") + "</td></tr>" + genHtml;
      } else {
        var id2 = "ychart-r-" + i;
        if (isSel && !hitId) hitId = id2;
        html += '<tr id="' + id2 + '"' + (isSel ? ' class="chart-hit"' : "") +
          '><td class="chart-sn">' + esc(m.stamp) + '</td><td style="white-space:nowrap;">' + esc(yamahaYearsText(m)) + "</td><td>" + esc(m.note || "") + "</td></tr>";
      }
    });
    html += "</tbody></table>";
    els["chart-title"].textContent = "Yamaha professional " + spec.size + " models";
    els["chart-wrap"].innerHTML = html;
    els["chart-note"].innerHTML = "Yamaha has never published serial charts, and none can exist — serial sequences run per model and were restarted at least twice (officially at #C00001 in October 2006). The windows above are catalog generations, verified against Yamaha press releases. Brand-wide Yamaha “serial charts” found elsewhere online are actually built on the Vito student-horn sequence and mis-date professional models by decades.";
    els["chart-section"].style.display = "block";
    if (hitId) {
      var row = document.getElementById(hitId);
      if (row) els["chart-wrap"].scrollTop = Math.max(0, row.offsetTop - 140);
    }
  }

  function setYamahaPermalink(raw) {
    try {
      var qs = "?brand=yamaha";
      if (state.ystamp) qs += "&model=" + encodeURIComponent(state.ystamp);
      else if (state.ysize) qs += "&size=" + encodeURIComponent(state.ysize);
      if (raw) qs += "&sn=" + encodeURIComponent(raw);
      history.replaceState(null, "", location.pathname + qs);
    } catch (e) { /* older browsers: nothing lost */ }
  }

  // The visitor just told us exactly what horn they have — carry it into
  // the valuation form at the bottom of the page so selling is one step
  // shorter. Never overwrite anything they typed themselves: only fill a
  // field that is empty or still holding our own previous prefill.
  function prefillValuationForm(brand, hit, raw) {
    var modelField = document.querySelector('#valuation-form input[name="contact[saxophone_model]"]');
    var serialField = document.querySelector('#valuation-form input[name="contact[serial_number]"]');
    var summary = DATA.brands[brand].name + (hit.model ? " — " + hit.model : "") + (hit.year ? " (" + hit.year + ")" : "");
    if (modelField && (modelField.value === "" || modelField.getAttribute("data-prefilled") === modelField.value)) {
      modelField.value = summary;
      modelField.setAttribute("data-prefilled", summary);
    }
    if (serialField && (serialField.value === "" || serialField.getAttribute("data-prefilled") === serialField.value)) {
      serialField.value = raw;
      serialField.setAttribute("data-prefilled", raw);
    }
  }

  function adolpheFactory(sn) {
    if (sn <= 3600) return "84, Rue Myrha, Paris";
    if (sn <= 6000) return "10, Rue Neuve-Saint-Georges, Paris";
    if (sn <= 20000) return "50, Rue Saint-Georges, Paris";
    if (sn <= 35000) return "26, Rue de Rocroy, Paris";
    if (sn <= 40000) return "56, Rue Laffitte, Paris";
    return "6, Rue Lallier, Paris";
  }

  function brandCaveats(brand, sn, year) {
    // Per-brand caveats declared in the data, keyed by a word in the year
    // band ("records lost") or a serial window — the clarinet page's
    // charts need them without a page-specific script.
    ((DATA.brands[brand] || {}).caveats || []).forEach(function (c, ci) {
      if (c.yearHas && year.indexOf(c.yearHas) === -1) return;
      if (c.lo !== undefined && sn < c.lo) return;
      if (c.hi !== undefined && sn > c.hi) return;
      caveat(DCSAX_LOC ? dcsaxT("brands." + brand + ".caveats." + ci + ".html", "") : c.html);
    });
    if (brand === "king") {
      caveat("<strong>Why a two-year band?</strong> H.N. White&rsquo;s factory records were destroyed when the company was sold — every King date is a collector reconstruction, and a band is the honest answer.");
    }
    if (brand === "conn" && sn < 260000) {
      caveat("<strong>Historical Note:</strong> Conn production records from this era are incomplete. Years shown are approximate based on the best available reference data.");
    }
    if (brand === "buescher" && year.indexOf("1942") !== -1 && year.indexOf("c.") !== -1) {
      caveat("<strong>WWII Production Gap:</strong> Buescher factory records from the war years are incomplete due to wartime material restrictions — precise dating is not possible from the serial number alone in this range.");
    }
    if (brand === "buescher" && sn > 312000 && sn <= 380999) {
      els["overlap-info-box"].style.display = "block";
      els["overlap-info-box"].innerHTML = "💡 <strong>Overlapping Production Notice:</strong> During this period, Buescher produced two distinct premium pro models side-by-side. Check your bell engraving to verify your model:<ul><li><strong>Buescher Aristocrat (&lsquo;Big B&rsquo;):</strong> a large block-lettered &lsquo;B&rsquo; on the bell with an art-deco saxophone player profile inside it.</li><li><strong>Buescher 400 (&lsquo;Top Hat &amp; Cane&rsquo;):</strong> a top hat, walking cane, and formal gloves engraving, with a silver resonance ring under the bell rim and an underslung octave key.</li></ul>";
    }
    if (brand === "keilwerth" && year.indexOf("1943") !== -1) {
      caveat("<strong>WWII Relocation Gap:</strong> In 1944, Keilwerth was forced to relocate from Graslitz to Nauheim, Germany, and production halted during the move — precise dating is not possible in this range.");
    }
    if (brand === "keilwerth" && year.indexOf("1946") !== -1) {
      caveat("<strong>Post-War Restart:</strong> Keilwerth restarted production in Nauheim around 1946–1947, resetting serial numbers at 20,000. The exact restart is approximate for serials in this range.");
    }
  }

  // ── the two actions + sold-archive rendering ───────────────────────────
  function showActions(hit) {
    els["lookup-actions"].style.display = "grid";
    els["show-sold-btn"].style.display = "";
  }

  // Once earned, the sell content and the bookmark nudge stay — no
  // vanishing sections while someone edits their serial.
  function revealExtras() {
    var extras = document.getElementById("post-lookup-extras");
    if (extras) extras.style.display = "block";
    if (els["save-row"]) els["save-row"].style.display = "flex";
  }

  // ── bookmark / copy-link buttons ───────────────────────────────────────
  // A page cannot add a bookmark itself. On a phone the button opens the
  // share sheet (which has Add Bookmark / Add to Home Screen); on a desktop
  // it shows the keyboard shortcut. The URL already carries the brand and
  // serial, so what gets saved is this exact result. Clicks are counted in
  // GA as bookmark_click and copy_link_click; completed bookmarks are not
  // visible to a page in any browser.
  function saveNote(html) {
    var hint = els["bookmark-hint"];
    if (!hint) return;
    hint.innerHTML = html;
    hint.style.display = "block";
  }
  function isTouch() { return !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches); }
  function isMac() { return /Mac|iP/.test(navigator.platform || ""); }

  if (els["bookmark-btn"]) els["bookmark-btn"].addEventListener("click", function () {
    var touch = isTouch();
    track("bookmark_click", { brand: state.brand || "(none)", device: touch ? "touch" : "desktop", method: (touch && navigator.share) ? "share_sheet" : "shortcut" });
    if (touch && navigator.share) {
      navigator.share({ title: document.title, url: location.href })
        .then(function () { saveNote(DCSAX_LOC ? dcsaxT("save.sheet", "") : "Choose <strong>Add Bookmark</strong> or <strong>Add to Home Screen</strong> in the sheet that opened."); })
        .catch(function () { saveNote(DCSAX_LOC ? dcsaxT("save.tap", "") : "Tap your browser&rsquo;s share icon, then <strong>Add Bookmark</strong>."); });
      return;
    }
    if (touch) {
      saveNote(DCSAX_LOC ? dcsaxT("save.tap", "") : "Tap your browser&rsquo;s share icon, then <strong>Add Bookmark</strong>.");
      return;
    }
    saveNote(DCSAX_LOC ? dcsaxF("save.press", [isMac() ? "\u2318 D" : "Ctrl+D"]) : "Press <strong>" + (isMac() ? "\u2318 D" : "Ctrl+D") + "</strong> to bookmark this page.");
  });

  if (els["copy-link-btn"]) els["copy-link-btn"].addEventListener("click", function () {
    var url = location.href;
    track("copy_link_click", { brand: state.brand || "(none)", device: isTouch() ? "touch" : "desktop" });
    function done() { saveNote(DCSAX_LOC ? dcsaxT("save.copied", "") : "Link copied."); }
    function fail() { saveNote(DCSAX_LOC ? dcsaxF("save.copyThis", [esc(url)]) : "Copy this link: <strong>" + esc(url) + "</strong>"); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(fail);
    } else {
      try {
        var ta = document.createElement("textarea");
        ta.value = url; ta.setAttribute("readonly", ""); ta.style.position = "absolute"; ta.style.left = "-9999px";
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand("copy");
        document.body.removeChild(ta);
        ok ? done() : fail();
      } catch (e) { fail(); }
    }
  });

  els["show-sold-btn"].addEventListener("click", function () {
    var box = els["sold-similar"];
    if (box.style.display === "block") { box.style.display = "none"; return; }
    box.style.display = "block";
    track("sold_similar_open", { brand: state.brand });
    if (!state.soldLoaded) loadSold();
  });

  // Sell-intent clicks and form submissions, for the usage picture.
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!a) return;
    if (a.getAttribute("data-track") === "sell_cta_goldbox") track("sell_cta_click", { source: "gold_box" });
    else if (a.getAttribute("href") === "/pages/sell") track("sell_cta_click", { source: "black_button" });
  });
  var vform = document.querySelector("#valuation-form form");
  if (vform) vform.addEventListener("submit", function () {
    track("valuation_submit", { brand: state.brand || "(none)", prefilled: state.lastTracked ? "yes" : "no" });
  });

  function searchQueries() {
    var plan = DATA.search[dataKey(state.brand, state.era)] || DATA.search[state.brand] || { base: [], fallback: [] };
    var terms = [];
    if (state.model && plan.byModel && plan.byModel[state.model]) {
      terms = plan.byModel[state.model].slice();
    } else {
      terms = plan.base.slice();
    }
    var queries = [];
    var y = state.year && /^\d{4}$/.test(state.year) ? state.year : null;
    if (y && terms.length) queries.push(terms[0] + " " + y);
    terms.forEach(function (t) { queries.push(t); });
    plan.fallback.forEach(function (t) { queries.push(t); });
    return queries.slice(0, 4);
  }

  function loadSold() {
    state.soldLoaded = true;
    els["sold-note"].textContent = DCSAX_LOC ? dcsaxT("sold.loading", "") : "Looking through our listings and sold archives…";
    var queries = searchQueries();
    var found = [];
    var seen = {};

    function finish() {
      els["sold-grid"].innerHTML = "";
      if (!found.length) {
        els["sold-note"].innerHTML = COPY.soldEmpty;
        return;
      }
      // For-sale listings first (owner, 2026-09-25: "In many cases, I may
      // have similar horns for sale"), then the sold archive. Search order
      // is kept inside each group.
      var forSale = found.filter(function (p) { return p.available; });
      var sold = found.filter(function (p) { return !p.available; });
      forSale.concat(sold).slice(0, 12).forEach(function (p) {
        var a = document.createElement("a");
        a.className = "sold-card";
        a.href = p.url;
        a.innerHTML = (p.available ? "" : DCSAX_LOC ? '<span class="sold-badge">' + dcsaxT("sold.badge", "") + "</span>" : '<span class="sold-badge">SOLD</span>') +
          (p.image ? '<img loading="lazy" alt="" src="' + esc(p.image) + '">' : "") +
          '<span class="sold-card-title">' + esc(p.title) + "</span>" +
          (p.available && p.price ? '<span class="sold-card-price">' + esc(p.price) + "</span>" : "");
        els["sold-grid"].appendChild(a);
      });
      track("similar_results", { brand: state.brand, for_sale: forSale.length, sold: sold.length });
      // No caption under the sold grid — "recently" wasn't always true
      // (owner, 2026-08-08); the SOLD badges speak for themselves.
      els["sold-note"].textContent = "";
    }

    function step(i) {
      if (i >= queries.length || found.length >= 12) { finish(); return; }
      var url = "/search/suggest.json?q=" + encodeURIComponent(queries[i]) +
        "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show";
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var products = (((json || {}).resources || {}).results || {}).products || [];
          products.forEach(function (p) {
            // Shopify appends _pos/_psq tracking to each result URL, so the
            // same product from two searches has two URLs. Dedup on handle.
            var key = p.handle || String(p.url).split("?")[0];
            if (seen[key]) return;
            seen[key] = true;
            var cents = Math.round(parseFloat(p.price || "0") * 100);
            found.push({
              url: p.url, title: p.title, image: p.image || p.featured_image || "",
              available: p.available !== false,
              price: cents > 0 ? "$" + fmt(Math.round(cents / 100)) : ""
            });
          });
          step(i + 1);
        })
        .catch(function () { step(i + 1); });
    }
    step(0);
  }

  // ── the full chart, highlighted ────────────────────────────────────────
  function factRow(f, hasModels) {
    var body;
    if (f[2] && f[3] === "textlink") {
      body = '<a href="' + esc(f[2]) + '">' + esc(f[1]) + "</a>";
    } else if (f[2]) {
      body = esc(f[1]) + ' — <a href="' + esc(f[2]) + '">read more</a>';
    } else {
      body = DCSAX_LOC ? esc(dcsaxFact(f)) : esc(f[1]);
    }
    return '<tr class="chart-fact"><td colspan="' + (hasModels ? 3 : 2) + '">→ ~' + fmt(f[0]) + " · " + body + "</td></tr>";
  }

  function splitByModel(brand, lo, hi) {
    var cuts = [];
    var ranges = DATA.models[brand] || (DATA.brands[brand].eras ? DATA.models[dataKey(brand, state.era)] : null) || [];
    ranges.forEach(function (r) {
      if (r[0] > lo && r[0] <= hi) cuts.push(r[0]);
    });
    cuts.sort(function (a, b) { return a - b; });
    var parts = [];
    var start = lo;
    cuts.forEach(function (c) { parts.push([start, c - 1]); start = c; });
    parts.push([start, hi]);
    return parts;
  }

  function renderChart(brand, sn, letteredHit) {
    if (letteredHit === undefined) letteredHit = null;
    var brandDef = DATA.brands[brand];
    if (!brandDef.sections.length && !brandDef.lettered) return;
    var hasModels = !!DATA.models[brand] || (brandDef.eras || []).some(function (e) { return !!DATA.models[dataKey(brand, e.key)]; });
    var html = DCSAX_LOC ? "<table><thead><tr><th>" + dcsaxT("chart.th.serial", "") + "</th><th>" + dcsaxT("chart.th.year", "") + "</th>" + (hasModels ? "<th>" + dcsaxT("chart.th.model", "") + "</th>" : "") + "</tr></thead><tbody>" : "<table><thead><tr><th>Serial numbers</th><th>Year</th>" + (hasModels ? "<th>Model era</th>" : "") + "</tr></thead><tbody>";
    var hitId = null;
    var savedEra = state.era;

    if (brandDef.lettered) {
      html += DCSAX_LOC ? '<tr class="chart-section-label"><td colspan="' + (hasModels ? 3 : 2) + '">' + esc(brandDef.letteredLabel ? dcsaxT("brands." + brand + ".letteredLabel", "") : dcsaxT("chart.lettered", "")) + "</td></tr>" : '<tr class="chart-section-label"><td colspan="' + (hasModels ? 3 : 2) + '">' + esc(brandDef.letteredLabel || "Lettered serials") + "</td></tr>";
      brandDef.lettered.forEach(function (row, i) {
        var isHit = letteredHit !== null && letteredHit === row[0];
        var id = "chart-l-" + i;
        if (isHit) hitId = id;
        html += DCSAX_LOC ? '<tr id="' + id + '"' + (isHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + esc(row[1]) + "</td><td>" + esc(dcsaxYear(row[0])) + "</td>" + (hasModels ? "<td>" + esc(dcsaxModel(brand, brandDef.letteredModel || "")) + "</td>" : "") + "</tr>" : '<tr id="' + id + '"' + (isHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + esc(row[1]) + "</td><td>" + esc(row[0]) + "</td>" + (hasModels ? "<td>" + esc(brandDef.letteredModel || "") + "</td>" : "") + "</tr>";
      });
    }

    brandDef.sections.forEach(function (sec, sIdx) {
      // Rows of an era-split brand read their models and facts under
      // that era's key, whichever era the visitor chose.
      if (brandDef.eras) state.era = sec.era;
      var inEra = !brandDef.eras || sec.era === savedEra;
      var factsFor = DATA.facts[dataKey(brand, brandDef.eras ? sec.era : "")] || DATA.facts[brand] || [];
      if (sec.label) {
        html += DCSAX_LOC ? '<tr class="chart-section-label"><td colspan="' + (hasModels ? 3 : 2) + '">' + esc(dcsaxT("brands." + brand + ".sections." + sIdx + ".label", sec.label)) + "</td></tr>" : '<tr class="chart-section-label"><td colspan="' + (hasModels ? 3 : 2) + '">' + esc(sec.label) + "</td></tr>";
      }
      var lo = sec.min;
      sec.steps.forEach(function (step, i) {
        var hi = step[0];
        // A year that straddles a model change becomes one row per model,
        // so no row ever claims a model for serials that aren't it
        // (owner pushback 2026-08-08: "the tables aren't honest yet").
        splitByModel(brand, lo, hi).forEach(function (part, j) {
          var isHit = inEra && sn !== null && sn >= part[0] && sn <= part[1];
          var id = "chart-r-" + sIdx + "-" + i + "-" + j;
          if (isHit) hitId = id;
          // Quiet fact rows sit ABOVE the range where their change lands.
          factsFor.forEach(function (f) {
            if (f[0] >= part[0] && f[0] <= part[1]) {
              html += factRow(f, hasModels);
            }
          });
          html += DCSAX_LOC ? '<tr id="' + id + '"' + (isHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + fmt(part[0]) + " – " + fmt(part[1]) + "</td><td>" + esc(dcsaxYear(step[1])) + "</td>" +
            (hasModels ? "<td>" + esc(dcsaxModel(brand, modelFor(brand, part[0]) || "")) + "</td>" : "") + "</tr>" : '<tr id="' + id + '"' + (isHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + fmt(part[0]) + " – " + fmt(part[1]) + "</td><td>" + esc(step[1]) + "</td>" +
            (hasModels ? "<td>" + esc(modelFor(brand, part[0]) || "") + "</td>" : "") + "</tr>";
        });
        lo = hi + 1;
      });
      if (sec.fallback) {
        var isFallbackHit = inEra && sn !== null && sn >= lo && (!sec.hardMax || sn <= sec.hardMax);
        var fid = "chart-f-" + sIdx;
        if (isFallbackHit) hitId = fid;
        factsFor.forEach(function (f) {
          if (f[0] >= lo && (!sec.hardMax || f[0] <= sec.hardMax)) {
            html += factRow(f, hasModels);
          }
        });
        html += DCSAX_LOC ? '<tr id="' + fid + '"' + (isFallbackHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + (sec.hardMax ? fmt(lo) + " – " + fmt(sec.hardMax) : dcsaxF("chart.andUp", [fmt(lo)])) + "</td><td>" + esc(dcsaxYear(sec.fallback)) + "</td>" + (hasModels ? "<td>" + esc(dcsaxModel(brand, modelFor(brand, lo) || "")) + "</td>" : "") + "</tr>" : '<tr id="' + fid + '"' + (isFallbackHit ? ' class="chart-hit"' : "") + '><td class="chart-sn">' + fmt(lo) + (sec.hardMax ? " – " + fmt(sec.hardMax) : " and up") + "</td><td>" + esc(sec.fallback) + "</td>" + (hasModels ? "<td>" + esc(modelFor(brand, lo) || "") + "</td>" : "") + "</tr>";
      }
    });
    state.era = savedEra;
    html += "</tbody></table>";

    els["chart-title"].textContent = DCSAX_LOC ? dcsaxF("chart.title", [dcsaxT("brands." + brand + ".name", "")]) : "Where your " + COPY.noun + " falls in the " + brandDef.name + " serial chart";
    els["chart-wrap"].innerHTML = html;
    els["chart-note"].innerHTML = DCSAX_LOC ? dcsaxT("brands." + brand + ".note", brandDef.note || "") : brandDef.note || "";
    els["chart-section"].style.display = "block";
    if (hitId) {
      var row = document.getElementById(hitId);
      if (row) els["chart-wrap"].scrollTop = Math.max(0, row.offsetTop - 140);
    }
  }

  // ── permalinks ─────────────────────────────────────────────────────────
  function setPermalink(brand, raw) {
    try {
      var qs = "?brand=" + encodeURIComponent(brand) + (state.era ? "&era=" + encodeURIComponent(state.era) : "") + (raw ? "&sn=" + encodeURIComponent(raw) : "");
      history.replaceState(null, "", location.pathname + qs);
    } catch (e) { /* older browsers: nothing lost */ }
  }

  try {
    var params = new URLSearchParams(location.search);
    var b = (params.get("brand") || "").toLowerCase();
    if (DATA.brands[b]) {
      var sn = params.get("sn") || "";
      if (sn) els["sax-sn"].value = sn;
      var pEra = (params.get("era") || "").toLowerCase();
      if (DATA.brands[b].eras && DATA.brands[b].eras.some(function (e) { return e.key === pEra; })) state.era = pEra;
      if (b === "yamaha") {
        var pModel = (params.get("model") || "").toUpperCase();
        var pSize = (params.get("size") || "").toLowerCase();
        var pSpec = pModel ? ySpecByStamp(pModel) : null;
        if (pSpec) { state.ystamp = pSpec.stamp; state.ysize = pSpec.size; }
        else if (DATA.yamaha.sizes.indexOf(pSize) !== -1) state.ysize = pSize;
      }
      selectBrand(b);
      runLookup();
      // Images above the tool can still be loading here; measure again once
      // the page has finished loading so the scroll lands in the right place.
      if (document.readyState !== "complete") window.addEventListener("load", function () { revealedBrand = null; revealResult(); });
    }
  } catch (e) { /* no prefill */ }
})();
